// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './DataTable.css';

// const DataTable = () => {
//     const [data, setData] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(10);
//     const [rowsPerPageOptions, setRowsPerPageOptions] = useState([10, 25, 50]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedRow, setSelectedRow] = useState(null);


//     useEffect(() => {
//         fetchData();
//       }, []);

//       const fetchData = async () => {
//         try {
//           const response = await axios.get('https://jsonplaceholder.typicode.com/users');
//           const fetchedData = response.data;

//           // Repeat fetched data 10-15 times to get 100 rows
//           let repeatedData = [];
//           for (let i = 0; i < 10; i++) {
//             repeatedData = repeatedData.concat(
//               fetchedData.map((item) => ({
//                 ...item,
//                 id: item.id + i * fetchedData.length,
//               }))
//             );
//           }

//           setData(repeatedData);
//         } catch (error) {
//           console.error('Error fetching data:', error);
//         }
//       };

//       const handleSearch = (event) => {
//         setSearchTerm(event.target.value);
//       };

//       const handleRowsPerPageChange = (event) => {
//         setItemsPerPage(parseInt(event.target.value, 10));
//         setCurrentPage(1); // Reset current page to the first page
//       };

//       const handleSort = (key) => {
//         let direction = 'asc';
//         if (sortConfig.key === key && sortConfig.direction === 'asc') {
//           direction = 'desc';
//         }
//         setSortConfig({ key, direction });
//       };

//       const handlePageClick = (newPage) => {
//         setCurrentPage(newPage);
//       };

//       const handleEditClick = (rowData) => {
//         setSelectedRow(rowData);
//         setShowModal(true);
//       };

//       const handleModalClose = () => {
//         setShowModal(false);
//       };

//       const handleSave = () => {
//         // Update the data state with the edited row data
//         setData((prevData) =>
//           prevData.map((item) => (item.id === selectedRow.id ? selectedRow : item))
//         );

//         // Close the modal
//         handleModalClose();

//         // Send the updated data to the server (assuming an API endpoint exists)
//         // axios.put(`https://yourapi.com/users/${selectedRow.id}`, selectedRow)
//         // .then((response) => {
//         //   console.log('Data saved:', response.data);
//         // })
//         // .catch((error) => {
//         //   console.error('Error saving data:', error);
//         // });
//       };


//       const filteredData = sortedData.filter((item) =>
//         item.name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const currentData = filteredData.slice(startIndex, endIndex);
//   return (
//     <div className='container'>
//         <div className='search-bar'>
//         <div className="search-wrapper">
//                <input
//                  type="text"
//                  placeholder="Search by name"
//                  value={searchTerm}
//                  onChange={handleSearch}
//                  className='search-input'
//                />
//                <i className="search-icon fas fa-search"></i>
//           </div>

//         </div>
//         <table className="table">
//           <thead>
//             <tr>
//               <th onClick={() => handleSort('id')}>ID</th>
//               <th onClick={() => handleSort('name')}>Name</th>
//               <th onClick={() => handleSort('email')}>Email</th>
//               <th onClick={() => handleSort('address.city')}>City</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentData.map((item) => (
//               <tr key={item.id}>
//                 <td>{item.id}</td>
//                 <td>{item.name}</td>
//                 <td>{item.email}</td>
//                 <td>{item.address.city}</td>
//                 <td>
//                     <button onClick={() => handleEditClick(item)}>Edit</button>
//                  </td>

//             </tr>
//           ))}
//         </tbody>
//       </table>
//               <div className="pagination-options">
//   <div className="rows-per-page">
//     Rows per page:
//     <select value={itemsPerPage} onChange={handleRowsPerPageChange}>
//       {rowsPerPageOptions.map((option) => (
//         <option key={option} value={option}>
//           {option}
//         </option>
//       ))}
//     </select>
//   </div>
//   <div className="pagination">
//     <button
//       onClick={() => handlePageClick(1)}
//       disabled={currentPage === 1}
//     >
//       First
//     </button>
//     <button
//       onClick={() => handlePageClick(currentPage - 1)}
//       disabled={currentPage === 1}
//     >
//       Previous
//     </button>
//     {Array.from({ length: totalPages }, (_, index) => index + 1).map(
//       (page) => (
//         <button
//           key={page}
//           onClick={() => handlePageClick(page)}
//           disabled={currentPage === page}
//         >
//           {page}
//         </button>
//       )
//     )}
//     <button
//       onClick={() => handlePageClick(currentPage + 1)}
//       disabled={currentPage === totalPages}
//     >
//       Next
//     </button>
//     <button
//       onClick={() => handlePageClick(totalPages)}
//       disabled={currentPage === totalPages}
//     >
//       Last
//     </button>
//   </div>
// </div>


//       {showModal && (
//   <div className="modal">
//     <div className="modal-content">
//       <h2>Edit User</h2>
//       <form>
//         <label>ID:</label>
//         <input type="text" value={selectedRow?.id} readOnly />

//         <label>Name:</label>
//         <input
//           type="text"
//           value={selectedRow?.name}
//           onChange={(e) =>
//             setSelectedRow((prev) => ({ ...prev, name: e.target.value }))
//           }
//         />

//         <label>Email:</label>
//         <input
//           type="text"
//           value={selectedRow?.email}
//           onChange={(e) =>
//             setSelectedRow((prev) => ({ ...prev, email: e.target.value }))
//           }
//         />

//         <label>City:</label>
//         <input
//           type="text"
//           value={selectedRow?.address.city}
//           onChange={(e) =>
//             setSelectedRow((prev) => ({
//               ...prev,
//               address: { ...prev.address, city: e.target.value },
//             }))
//           }
//         />
//       </form>
//       <button onClick={handleSave}>Save</button>
//       <button onClick={handleModalClose}>Close</button>
//     </div>
//     </div>
// )}
//     </div>
//   )
// }

// export default DataTable

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Datatable.css';
// // icons 
// import { FiEdit } from "react-icons/fi";
// import { API } from './constant';

// const DataTable = () => {
//     const [data, setData] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [searchClass, setSearchClass] = useState('');
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(50);
//     const [rowsPerPageOptions, setRowsPerPageOptions] = useState([50, 100, 150]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedRow, setSelectedRow] = useState(null);

//     useEffect(() => {
//         fetchData();
//     }, []);

//     const fetchData = async () => {
//         try {
//             // const response = await axios.get('https://jsonplaceholder.typicode.com/users');
//             const response = await axios.get(`${API}/upload`);
//             console.log(response)
//             const fetchedData = response.data.data;

//             // Repeat fetched data 10 times to get 100 rows
//             // let repeatedData = [];
//             // for (let i = 0; i < 10; i++) {
//             //     repeatedData = repeatedData.concat(
//             //         fetchedData.map((item) => ({
//             //             ...item,
//             //             id: item.id + i * fetchedData.length,
//             //         }))
//             //     );
//             // }

//             setData(fetchedData);
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };

//     const handleSearch = (event) => {
//         setSearchTerm(event.target.value);
//     };
//     const handleSearchClass = (event) => {
//         setSearchClass(event.target.value);
//     };

//     const handleRowsPerPageChange = (event) => {
//         setItemsPerPage(parseInt(event.target.value, 10));
//         setCurrentPage(1); // Reset current page to the first page
//     };

//     const handleSort = (key) => {
//         let direction = 'asc';
//         if (sortConfig.key === key && sortConfig.direction === 'asc') {
//             direction = 'desc';
//         }
//         setSortConfig({ key, direction });
//     };

//     const handlePageClick = (newPage) => {
//         setCurrentPage(newPage);
//     };

//     const handleEditClick = (rowData) => {
//         setSelectedRow(rowData);
//         setShowModal(true);
//     };

//     const handleModalClose = () => {
//         setShowModal(false);
//     };

//     const handleSave = () => {
//         // Update the data state with the edited row data
//         setData((prevData) =>
//             prevData.map((item) => (item.id === selectedRow.id ? selectedRow : item))
//         );

//         // Close the modal
//         handleModalClose();

//         // Send the updated data to the server (assuming an API endpoint exists)
//         // axios.put(`https://yourapi.com/users/${selectedRow.id}`, selectedRow)
//         // .then((response) => {
//         //   console.log('Data saved:', response.data);
//         // })
//         // .catch((error) => {
//         //   console.error('Error saving data:', error);
//         // });
//     };

//     const sortedData = [...data].sort((a, b) => {
//         if (sortConfig.key) {
//             const aValue = sortConfig.key.split('.').reduce((o, k) => o[k], a);
//             const bValue = sortConfig.key.split('.').reduce((o, k) => o[k], b);
//             if (aValue < bValue) {
//                 return sortConfig.direction === 'asc' ? -1 : 1;
//             }
//             if (aValue > bValue) {
//                 return sortConfig.direction === 'asc' ? 1 : -1;
//             }
//             return 0;
//         }
//         return 0;
//     });

//     const filteredData = sortedData.filter((item) =>
//         item.name.toLowerCase().includes(searchTerm.toLowerCase())
//     && item.class.toLowerCase().includes(searchClass.toLowerCase())
//     );

//     const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const currentData = filteredData.slice(startIndex, endIndex);

//     return (
//         <div className='container'>
//             <div className='flex gap-3'>
//             <div className='search-bar'>
//                 <div className="search-wrapper">
//                     <input
//                         type="text"
//                         placeholder="Search by name"
//                         value={searchTerm}
//                         onChange={handleSearch}
//                         className='search-input'
//                     />
//                     <i className="search-icon fas fa-search"></i>
//                 </div>
//             </div>
//             <div className='search-bar'>
//                 <div className="search-wrapper">
//                     <input
//                         type="text"
//                         placeholder="Search by Class"
//                         value={searchClass}
//                         onChange={handleSearchClass}
//                         className='search-input'
//                     />
//                     <i className="search-icon fas fa-search"></i>
//                 </div>
//             </div>
//             </div>
//             <table className="table">
//                 <thead>
//                     <tr>
//                         {/* <th onClick={() => handleSort('id')}>ERPID</th>
//                         <th onClick={() => handleSort('name')}>Name</th>
//                         <th onClick={() => handleSort('email')}>Class</th>
//                         <th onClick={() => handleSort('address.city')}>Section</th> */}
//                         <th onClick={() => handleSort('erpId')}>ERPID</th>
//                         <th onClick={() => handleSort('name')}>Name</th>
//                         <th onClick={() => handleSort('class')}>Class</th>
//                         <th onClick={() => handleSort('section')}>Section</th>
//                         <th onClick={() => handleSort('lexile')}>Lexile</th>
//                         <th>Update</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentData.map((item) => (
//                         <tr key={item.id}>
//                             <td>{item.erpId}</td>
//                             <td>{item.name}</td>
//                             <td>{item.class}</td>
//                             <td>{item.section}</td>
//                             <td>{item.lexile}</td>
//                             {/* <td>{item.address.city}</td> */}
//                             <td>
//                                 <button onClick={() => handleEditClick(item)}>Edit</button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//             <div className="pagination-options">
//                 <div className="rows-per-page">
//                     Rows per page:
//                     <select value={itemsPerPage} onChange={handleRowsPerPageChange}>
//                         {rowsPerPageOptions.map((option) => (
//                             <option key={option} value={option}>
//                                 {option}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="pagination">
//                     <button
//                         onClick={() => handlePageClick(1)}
//                         disabled={currentPage === 1}
//                     >
//                         First
//                     </button>
//                     <button
//                         onClick={() => handlePageClick(currentPage - 1)}
//                         disabled={currentPage === 1}
//                     >
//                         Previous
//                     </button>
//                     {Array.from({ length: totalPages }, (_, index) => index + 1).map(
//                         (page) => (
//                             <button
//                                 key={page}
//                                 onClick={() => handlePageClick(page)}
//                                 disabled={currentPage === page}
//                             >
//                                 {page}
//                             </button>
//                         )
//                     )}
//                     <button
//                         onClick={() => handlePageClick(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                     >
//                         Next
//                     </button>
//                     <button
//                         onClick={() => handlePageClick(totalPages)}
//                         disabled={currentPage === totalPages}
//                     >
//                         Last
//                     </button>
//                 </div>
//             </div>
//             {showModal && (
//                 <div className="modal">
//                     <div className="modal-content">
//                         <h2 className='font-bold'>Edit User</h2>
//                         <form>
//                             <label>ID:</label>
//                             <input type="text" value={selectedRow?.erpId} readOnly />
//                             <label>Name:</label>
//                             <input
//                                 type="text"
//                                 value={selectedRow?.name}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, name: e.target.value }))
//                                 }
//                             />
//                             <label>Class:</label>
//                             <input
//                                 type="text"
//                                 value={selectedRow?.class}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, class: e.target.value }))
//                                 }
//                             />
//                             <label>Section:</label>
//                             <input
//                                 type="text"
//                                 value={selectedRow?.section}
//                                 // onChange={(e) =>
//                                 //     setSelectedRow((prev) => ({
//                                 //         ...prev,
//                                 //         address: { ...prev.address, city: e.target.value },
//                                 //     }))
//                                 // }
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({
//                                         ...prev, section: e.target.value
//                                     }),
//                                     )
//                                 }
//                             />
//                             <label>Lexile:</label>
//                             <input
//                                 type="text"
//                                 value={selectedRow?.lexile}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, lexile: e.target.value }))
//                                 }
//                             />
//                         </form>
//                         <button onClick={handleSave}>Save</button>
//                         <button onClick={handleModalClose}>Close</button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default DataTable;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Datatable.css';
// // icons 
// import { FiEdit } from "react-icons/fi";
// import { API } from './constant';

// const DataTable = () => {
//     const [data, setData] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [searchClass, setSearchClass] = useState('');
//     const [searchSection, setSearchSection] = useState('');
//     const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(50);
//     const [rowsPerPageOptions, setRowsPerPageOptions] = useState([50, 100, 150]);
//     const [showModal, setShowModal] = useState(false);
//     const [selectedRow, setSelectedRow] = useState(null);
//     const [classSections, setClassSections] = useState({});
//     const [updateTable,setupdateTable]=useState(false)


//     useEffect(() => {
//     fetchData();
//     }, []);

//     const fetchData = async () => {
//         try {
//             const response = await axios.get(`${API}/upload`);
//             const fetchedData = response.data.data;

//             // Create classSections mapping
//             const classSectionsMap = fetchedData.reduce((acc, item) => {
//                 if (!acc[item.class]) {
//                     acc[item.class] = new Set();
//                 }
//                 acc[item.class].add(item.section);
//                 return acc;
//             }, {});

//             // Convert sets to arrays
//             for (let cls in classSectionsMap) {
//                 classSectionsMap[cls] = Array.from(classSectionsMap[cls]);
//             }

//             setClassSections(classSectionsMap);
//             setData(fetchedData);
//             // setupdateTable(!updateTable)
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };

//     const handleSearch = (event) => {
//         setSearchTerm(event.target.value);
//     };

//     const handleSearchClass = (event) => {
//         setSearchClass(event.target.value);
//         setSearchSection(''); // Reset section when class changes
//     };

//     const handleSearchSection = (event) => {
//         setSearchSection(event.target.value);
//     };

//     const handleRowsPerPageChange = (event) => {
//         setItemsPerPage(parseInt(event.target.value, 10));
//         setCurrentPage(1); // Reset current page to the first page
//     };

//     const handleSort = (key) => {
//         let direction = 'asc';
//         if (sortConfig.key === key && sortConfig.direction === 'asc') {
//             direction = 'desc';
//         }
//         setSortConfig({ key, direction });
//     };

//     const handlePageClick = (newPage) => {
//         setCurrentPage(newPage);
//     };

//     const handleEditClick = (rowData) => {
//         setSelectedRow(rowData);
//         setShowModal(true);
//     };

//     const handleModalClose = () => {
//         setShowModal(false);
//     };

//     // const handleSave = () => {

//     //     setData((prevData) =>
//     //         prevData.map((item) => (item.id === selectedRow.id ? selectedRow : item))
//     //     );
//     //     handleModalClose();
//     // };

//     const handleSave = async () => {
//         try {
//             await axios.put(`${API}/upload/update-lexile`, {
//                 erpId: selectedRow.erpId,
//                 lexile: selectedRow.lexile,
//             });

//             // Update the data state with the edited row data
//             setData((prevData) =>
//                 prevData.map((item) => (item.id === selectedRow.id ? selectedRow : item))
//             );

//             // Close the modal
//             handleModalClose();
//         } catch (error) {
//             console.error('Error updating Lexile value:', error);
//         }
//     };


//     const sortedData = [...data].sort((a, b) => {
//         if (sortConfig.key) {
//             const aValue = sortConfig.key.split('.').reduce((o, k) => o[k], a);
//             const bValue = sortConfig.key.split('.').reduce((o, k) => o[k], b);
//             if (aValue < bValue) {
//                 return sortConfig.direction === 'asc' ? -1 : 1;
//             }
//             if (aValue > bValue) {
//                 return sortConfig.direction === 'asc' ? 1 : -1;
//             }
//             return 0;
//         }
//         return 0;
//     });

//     const filteredData = sortedData.filter((item) =>
//         item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
//         item.class.toLowerCase().includes(searchClass.toLowerCase()) &&
//         item.section.toLowerCase().includes(searchSection.toLowerCase())
//     );

//     const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const currentData = filteredData.slice(startIndex, endIndex);

//     return (
//         <div className='container'>
//             <div className='flex gap-3 text-center'>
//                 <div className='search-bar'>
//                     <div className="search-wrapper">
//                         <input
//                             type="text"
//                             placeholder="Search by name"
//                             value={searchTerm}
//                             onChange={handleSearch}
//                             className='search-input'
//                         />
//                         <i className="search-icon fas fa-search"></i>
//                     </div>
//                 </div>
//                 <div className='search-bar'>
//                     <div className="search-wrapper">
//                         <select
//                             value={searchClass}
//                             onChange={handleSearchClass}
//                             className='search-input'
//                         >
//                             <option value="">Select Class</option>
//                             {Object.keys(classSections).map((cls) => (
//                                 <option key={cls} value={cls}>{cls}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//                 <div className='search-bar -z-10'>
//                     <div className="search-wrapper ">
//                         <select
//                             value={searchSection}
//                             onChange={handleSearchSection}
//                             className='search-input '
//                             disabled={!searchClass}
//                         >
//                             <option  value="">Select Section</option>
//                             {searchClass && classSections[searchClass].map((section) => (
//                                 <option key={section} value={section}>{section}</option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//             </div>
//             <table className="table">
//                 <thead>
//                     <tr>
//                         <th onClick={() => handleSort('erpId')}>ERPID</th>
//                         <th onClick={() => handleSort('name')}>Name</th>
//                         <th onClick={() => handleSort('class')}>Class</th>
//                         <th onClick={() => handleSort('section')}>Section</th>
//                         <th onClick={() => handleSort('lexile')}>Lexile</th>
//                         <th>Update</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {currentData.map((item) => (
//                         <tr key={item.id}>
//                             <td>{item.erpId}</td>
//                             <td>{item.name}</td>
//                             <td>{item.class}</td>
//                             <td>{item.section}</td>
//                             <td>{item.lexile}</td>
//                             <td>
//                                 <button onClick={() => handleEditClick(item)}>Edit</button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//             <div className="pagination-options">
//                 <div className="rows-per-page">
//                     Rows per page:
//                     <select value={itemsPerPage} onChange={handleRowsPerPageChange}>
//                         {rowsPerPageOptions.map((option) => (
//                             <option key={option} value={option}>
//                                 {option}
//                             </option>
//                         ))}
//                     </select>
//                 </div>
//                 <div className="pagination">
//                     <button
//                         onClick={() => handlePageClick(1)}
//                         disabled={currentPage === 1}
//                     >
//                         First
//                     </button>
//                     <button
//                         onClick={() => handlePageClick(currentPage - 1)}
//                         disabled={currentPage === 1}
//                     >
//                         Previous
//                     </button>
//                     {Array.from({ length: totalPages }, (_, index) => index + 1).map(
//                         (page) => (
//                             <button
//                                 key={page}
//                                 onClick={() => handlePageClick(page)}
//                                 disabled={currentPage === page}
//                             >
//                                 {page}
//                             </button>
//                         )
//                     )}
//                     <button
//                         onClick={() => handlePageClick(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                     >
//                         Next
//                     </button>
//                     <button
//                         onClick={() => handlePageClick(totalPages)}
//                         disabled={currentPage === totalPages}
//                     >
//                         Last
//                     </button>
//                 </div>
//             </div>
//             {showModal && (
//                 <div className="modal">
//                     <div className="modal-content">
//                         <h2 className='font-bold'>Edit Lexile</h2>
//                         <form>
//                             <label>ID:</label>
//                             <input className='outline-none border-[1px] border-black ' type="text" value={selectedRow?.erpId} readOnly />
//                             <label>Name:</label>
//                             <input
//                                 type="text"
//                                 className='outline-none border-[1px] border-black '
//                                 value={selectedRow?.name}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, name: e.target.value }))
//                                 }
//                                 readOnly
//                             />
//                             <label>Class:</label>
//                             <input
//                                 type="text"
//                                 className='outline-none border-[1px] border-black '
//                                 value={selectedRow?.class}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, class: e.target.value }))
//                                 }
//                                 readOnly
//                             />
//                             <label>Section:</label>
//                             <input
//                                 type="text"
//                                 className='outline-none border-[1px] border-black '
//                                 value={selectedRow?.section}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({
//                                         ...prev, section: e.target.value
//                                     }))
//                                 }
//                                 readOnly
//                             />
//                             <label>Lexile:</label>
//                             <input
//                                 type="text"
//                                 className='outline-none border-[1px] border-[#6C7AE0] '
//                                 value={selectedRow?.lexile}
//                                 onChange={(e) =>
//                                     setSelectedRow((prev) => ({ ...prev, lexile: e.target.value }))
//                                 }
//                             />
//                         </form>
//                         <button onClick={handleSave}>Save</button>
//                         <button onClick={handleModalClose}>Close</button>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default DataTable;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { debounce } from "lodash";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import axios from 'axios';
import './Datatable.css';
import { API } from './constant';
import Pagination from './Pagination'; // Import the Pagination component
import { MdClose } from "react-icons/md";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { GrScorecard } from "react-icons/gr";


// images
import srjlogo from "../assets/srjlogo.png"
import logo from "../assets/logo.jpg"
import gzp_logo from "../assets/SAJS-Gzb.jpg"
import knpr_logo from "../assets/SAJS-Kanpur.jpg"
import lko_logo from "../assets/SAJS-Lko.jpg"
import background_img from "../assets/background image report card.jpg"
import Lexile_rubric from "../assets/Lexile_rubric.png"
import reading_speed from "../assets/reading_speed.png"
import Lexile_child_reading from "../assets/Lexile-child-reading.webp"

// icons 
import { IoMdCloseCircle } from "react-icons/io";
import { FaSun } from "react-icons/fa6";
import { ImEnlarge2 } from "react-icons/im";
import { FiMinimize2 } from "react-icons/fi";

// documention pdf start 
import teacher from "../assets/Guide/teacher.pdf"
import admin from "../assets/Guide/admin.pdf"


// speech recoginition start 
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import throttle from "lodash.throttle";
// speech recoginition end

// operation on chart js start 
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js"
import BarChart from "./BarChart"
import { Button } from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
Chart.register(CategoryScale);
// operation on chart js end






const DataTable = () => {



    const tableRef = useRef(null);
    const exportTableRef = useRef(null);


    //============================ print functionality state  start ====================================
    const printRef = useRef();
    const chartRef = useRef(null);
    //============================ print functionality state  end ====================================



    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchClass, setSearchClass] = useState('');
    const [searchSection, setSearchSection] = useState('');
    const [searchSession, setSearchSession] = useState('');
    // console.log(searchSession)
    const [searchQuarter, setSearchQuarter] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(1000);
    const [rowsPerPageOptions, setRowsPerPageOptions] = useState([1000]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [classSections, setClassSections] = useState({});
    const [updateTable, setUpdateTable] = useState(false);
    const [enlargeTable, setenlargeTable] = useState(false)
    // console.log(selectedRow)
    const [showRubric, setShowRubric] = useState(false)

    // showmodal view change to table and basic start 
    const [evaluateView, setevaluateView] = useState("")
    // showmodal view change to table and basic end



    // =====================================showmodal question state start ====================================
    const [showModalQuestions, setshowModalQuestions] = useState(false)
    const [paragraphName, setparagraphName] = useState([])
    const [selectedParagraph, setselectedParagraph] = useState("")
    // =====================================showmodal question state end ====================================


    // switch between view and edit questions of modal start 
    const [showView, setshowView] = useState(true)

    // switch between view and edit questions of modal end

    //============= ============find user role and give permission start ============================
    const [loggedinRole, setLoggedinRole] = useState("")
    const [loggedinLocation, setloggedinLocation] = useState("")
    // console.log(loggedinRole)
    // useEffect(() => {
    //     axios.get(`${API}/login/logged-in-user`, {
    //         headers: {
    //             "Content-Type": "application/json",
    //             "token": localStorage.getItem("token")
    //         }
    //     })
    //         .then((res) => {
    //             setLoggedinRole(res.data.data.role)
    //         })
    //         .catch((err) => {
    //             // console.log(err);
    //             if (err.response) {
    //                 // Handle invalid token
    //                 if (err.response.status === 401) {
    //                     localStorage.removeItem("token");   
    //                     // history.push('/');
    //                     window.location.href = "/"
    //                 }
    //                 // Handle token expiration
    //                 else if (err.response.status === 302) {
    //                     window.location.href = "/"

    //                 }
    //             }
    //         });
    // }, [])

    //============= ============find user role and give permission end ============================



    // ======================speech recognition state start =============================
    const [paragraph, setParagraph] = useState("");
    const [spokenWords, setSpokenWords] = useState("");
    const [cumulativeSpokenWords, setCumulativeSpokenWords] = useState([]);
    const { transcript, interimTranscript, finalTranscript, resetTranscript } = useSpeechRecognition();
    const [spokenWordsLength, setSpokenWordsLength] = useState(0);

    // Update cumulative spoken words when the transcript changes
    //    useEffect(() => {
    //     if (transcript.trim()) {
    //         setCumulativeSpokenWords(prev => [...prev, ...transcript.trim().split(" ")]);
    //         resetTranscript(); // Reset the live transcript to track the next set of words
    //     }
    // }, [transcript]);



    useEffect(() => {
        if (showView && paragraphName && selectedRow && selectedRow.selected_paragraph !== "") {
            const filteredParagraph = paragraphName.find(
                (item) => item.paragraph_name === selectedRow.selected_paragraph
            );

            if (filteredParagraph) {
                // console.log(filteredParagraph.paragraph_details)
                setParagraph(filteredParagraph.paragraph_details);
            }
        }
    }, [paragraphName, selectedRow]);



    // calculate the total spoken words by the user start 
    useEffect(() => {
        setSpokenWordsLength(spokenWords.length);
    }, [spokenWords])
    // calculate the total spoken words by the user end


    // Reset the transcript if necessary
    // useEffect(() => {
    //     if (!showView) resetTranscript();
    // }, [showView, resetTranscript]);



    // ----------working useeffetct code start --------------------
    useEffect(() => {
        // Update spokenWords whenever interimTranscript or finalTranscript changes
        const interimWords = interimTranscript.trim().split(" ");
        const finalWords = finalTranscript.trim().split(" ");

        // Combine interim and final for better guessing
        const combinedWords = [...finalWords, ...interimWords.slice(finalWords.length)];
        setSpokenWords(combinedWords);
    }, [interimTranscript, finalTranscript]);
    // ----------working useeffetct code end --------------------

    // useEffect(() => {
    //     // Split interim and final transcripts into individual words
    //     const interimWords = interimTranscript.trim().split(" ");
    //     const finalWords = finalTranscript.trim().split(" ");

    //     // Combine interim and final for comparison
    //     const combinedWords = [...finalWords, ...interimWords.slice(finalWords.length)];

    //     // Split paragraph into words for comparison
    //     const paragraphWords = paragraph.split(" ").filter(word => word.trim() !== "");

    //     // Filter out mispronounced words
    //     const validSpokenWords = combinedWords.filter((word, index) => {
    //         // Only add to spokenWords if it matches the paragraph word at the same index
    //         return word.toLowerCase() === paragraphWords[index]?.toLowerCase();
    //     });

    //     setSpokenWords(validSpokenWords);
    // }, [interimTranscript, finalTranscript, paragraph]);






    // useEffect(() => {
    //     const paragraphWords = paragraph.trim().split(" "); // Words in the paragraph
    //     const finalWords = finalTranscript.trim().split(" "); // Final spoken words
    //     const updatedSpokenWords = [...spokenWords]; // Preserve previously spoken correct words

    //     let pointer = updatedSpokenWords.length; // Start where we left off

    //     finalWords.forEach((word) => {
    //         if (pointer < paragraphWords.length) {
    //             const expectedWord = paragraphWords[pointer]; // Expected word
    //             if (word.toLowerCase() === expectedWord.toLowerCase()) {
    //                 updatedSpokenWords.push(word); // Add only if correct
    //                 pointer++; // Move to the next expected word
    //             }
    //         }
    //     });

    //     setSpokenWords(updatedSpokenWords); // Update spokenWords
    // }, [finalTranscript, paragraph]);


    // Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag state start
    // useEffect(() => {
    //     const combinedWords = finalTranscript.trim().split(" "); // Prioritize final transcript
    //     const interimWords = interimTranscript.trim().split(" ");

    //     // Append only new words from interimTranscript
    //     const updatedSpokenWords = [...spokenWords];
    //     for (let i = combinedWords.length; i < interimWords.length; i++) {
    //         updatedSpokenWords.push(interimWords[i]);
    //     }

    //     setSpokenWords(updatedSpokenWords);
    // }, [interimTranscript, finalTranscript]);

    // Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag state  end
    // ======================speech recognition state end =============================





    // =======================operation on building timer states start ===========================
    const initialTime = 59
    const [timerSec, settimerSec] = useState(initialTime)
    const [timerMessage, settimerMessage] = useState(false)
    const timerIntervalRef = useRef(null); // useRef to store the interval ID
    // =======================operation on building timer states end ===========================




    // =========================operation on report card state start ============================
    const [showReportCard, setshowReportCard] = useState(false)
    const [chartData, setChartData] = useState({
        // labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        // labels: ['Class Averag', 'Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
        // datasets: [
        //     {
        //         label: 'Lexile scor',
        //         data: [65, 59, 80, 81, 56, 55],
        //         backgroundColor: 'rgba(255, 99, 132, 0.2)',
        //         borderColor: 'rgba(255, 99, 132, 1)',
        //         borderWidth: 1,
        //     },
        // ],
    });
    const [reportaverageLexile, setreportaverageLexile] = useState("")
    const [reportName, setreportName] = useState("")
    const [reportClass, setreportClass] = useState("")
    const [reportData, setreportData] = useState([])
    // =========================operation on report card state end ============================





    // const fetchData = async () => {
    //     try {
    //         // Fetch the user's data including permissions
    //         const userResponse = await axios.get(`${API}/login/logged-in-user`); // Assuming this endpoint returns the logged-in user's data
    //         const user = userResponse.data.data;
    //         const userPermissions = user.permissions;

    //         const response = await axios.get(`${API}/upload`);
    //         const fetchedData = response.data.data;
    //         // console.log(fetchedData)
    //         // Create classSections mapping
    //         const classSectionsMap = fetchedData.reduce((acc, item) => {

    //             if (!acc[item.class]) {
    //                 acc[item.class] = new Set();
    //             }
    //             acc[item.class].add(item.section);
    //             return acc;
    //         }, {});

    //         // console.log(classSectionsMap)

    //         // Convert sets to arrays
    //         for (let cls in classSectionsMap) {
    //             classSectionsMap[cls] = Array.from(classSectionsMap[cls]);
    //         }

    //         setClassSections(classSectionsMap);
    //         setData(fetchedData);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    // ----------get all school location start -----------
    const [allLocationData, setallLocationData] = useState([])
    const [schoolLocation, setschoolLocation] = useState(`${loggedinLocation}`)

    useEffect(() => {
        axios.get(`${API}/school-location`)
            .then((res) => {
                // console.log(res)
                setallLocationData(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])

    const handleSchoolLocationChange = (e) => {
        setschoolLocation(e.target.value);
    };
    // ----------get all school location end-----------






    // const fetchData = async () => {
    //     try {
    //         // Fetch the user's data including permissions
    //         const userResponse = await axios.get(`${API}/login/logged-in-user`, {
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 "token": localStorage.getItem("token")
    //             }
    //         }); // Assuming this endpoint returns the logged-in user's data
    //         const user = userResponse.data.data;
    //         const userSchoolLocation = userResponse.data.data.school_location;
    //         // console.log(user)
    //         console.log(schoolLocation)
    //         console.log(userSchoolLocation)
    //         const userPermissions = user.permissions;
    //         setLoggedinRole(user.role)
    //         setloggedinLocation(user.school_location)
    //         // console.log(user.school_location)

    //         const response = await axios.get(`${API}/upload`);
    //         const fetchedData = response.data.data;



    //         // Filter the fetched data based on user permissions
    //         //if user is admin then filter data based on schoolLocation else filter it based on userSchoolLocation

    //         const filteredData = fetchedData
    //             .filter(item => item.school_location === userSchoolLocation)
    //             .filter(item => {
    //                 return userPermissions.some(permission => {
    //                     return permission.class_name === item.class && permission.sections.includes(item.section);
    //                 });
    //             });

    //         // Create classSections mapping
    //         const classSectionsMap = filteredData
    //             .reduce((acc, item) => {
    //                 if (!acc[item.class]) {
    //                     acc[item.class] = new Set();
    //                 }
    //                 acc[item.class].add(item.section);
    //                 return acc;
    //             }, {});

    //         // console.log(classSectionsMap)


    //         // Convert sets to arrays
    //         for (let cls in classSectionsMap) {
    //             classSectionsMap[cls] = Array.from(classSectionsMap[cls]);
    //         }
    //         // console.log(filteredData)
    //         setClassSections(classSectionsMap);
    //         setData(filteredData);
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    const [totalCount, setTotalCount] = useState(0);




    // Fetch user info first
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const userResponse = await axios.get(`${API}/login/logged-in-user`, {
                    headers: {
                        "Content-Type": "application/json",
                        "token": localStorage.getItem("token")
                    }
                });
                const user = userResponse.data.data;
                setLoggedinRole(user.role);
                setloggedinLocation(user.school_location);
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchUser();
    }, []);



    const fetchData = async () => {
        try {
            // Fetch the user's data including permissions
            const userResponse = await axios.get(`${API}/login/logged-in-user`, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            }); // Assuming this endpoint returns the logged-in user's data
            const user = userResponse.data.data;
            const userSchoolLocation = user.school_location;
            const userPermissions = user.permissions;
            setLoggedinRole(user.role);
            setloggedinLocation(user.school_location);

            // const fetchAllDataUpload = await axios.get(`${API}/upload`);
            // const fetchedAllData = fetchAllDataUpload.data.data

            const response = await axios.get(`${API}/upload/limit`, {
                params: {
                    page: currentPage,
                    limit: itemsPerPage,
                    // send search term
                    name: searchTerm.trim(), // send search term
                    school_location: loggedinRole === "Super Admin" ? schoolLocation : loggedinLocation, // send selected school location
                    class: searchClass, // send selected class
                    section: searchSection, // send selected section
                    // academic_session: fetcheddefaultSession, // send selected session
                    //FILTER BASED ON SUPER ADMIN ROLE 
                    // academic_session: loggedinRole === "Super Admin" ? searchSession : fetcheddefaultSession, // send selected session
                    //filter based on super admin and admin
                    academic_session: loggedinRole === "Super Admin" || loggedinRole === "Admin" ? searchSession : fetcheddefaultSession, // send selected session
                    // academic_session: loggedinRole === "Super Admin" ? searchSession : fetcheddefaultSession, // send selected session
                    quarter: searchQuarter, // send selected quarter
                },
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            });
            const fetchedData = response.data.data;

            let filteredData = [];

            if (user.role === "Super Admin") {
                // Super Admin: filter by selected schoolLocation if set, else show all
                // filteredData = schoolLocation
                //     ? fetchedData.filter(item => item.school_location === schoolLocation)
                //     : fetchedData;
                // ...existing code...
                // console.log("Super Admin");
                filteredData = schoolLocation
                    ? fetchedData.filter(
                        item =>
                            item.school_location &&
                            item.school_location.trim().toLowerCase() === schoolLocation.trim().toLowerCase()
                    )
                    : fetchedData;
                // ...existing code...

                // Super Admin has access to all classes and sections
            } else {
                // Other users: filter by user's school location and permissions
                filteredData = fetchedData
                    .filter(item => item.school_location === userSchoolLocation)
                    .filter(item => {
                        return userPermissions.some(permission => {
                            return permission.class_name === item.class && permission.sections.includes(item.section);
                        });
                    });
            }

            // Create classSections mapping
            // const classSectionsMap = fetchedAllData.reduce((acc, item) => {
            //     if (!acc[item.class]) {
            //         acc[item.class] = new Set();
            //     }
            //     acc[item.class].add(item.section);
            //     return acc;
            // }, {});

            // Convert sets to arrays
            // for (let cls in classSectionsMap) {
            //     classSectionsMap[cls] = Array.from(classSectionsMap[cls]);
            // }

            // console.log(classSectionsMap)

            // setClassSections(classSectionsMap);
            // setData(filteredData);
            setData(response.data.data);
            // Set total count based on selected school location (case-insensitive, fallback to sum if not found)
            if (response.data.total) {
                // Use the correct location key based on role
                const totalObj = response.data.total;
                const locationKey = (loggedinRole === "Super Admin" ? schoolLocation : loggedinLocation) || "";
                // console.log(locationKey)
                const locKey = Object.keys(totalObj).find(
                    key => key.trim().toLowerCase() === locationKey.trim().toLowerCase()
                );
                if (locKey) {
                    setTotalCount(totalObj[locKey]);
                } else {
                    // If not found, fallback to sum of all
                    setTotalCount(Object.values(totalObj).reduce((sum, val) => sum + val, 0));
                }
            } else {
                setTotalCount(response.data.total || 0);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        axios.get(`${API}/upload/class-sections`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setClassSections(res.data.data)
            })
            .catch(err => console.error(err));
    }, []);





    useEffect(() => {
        if (loggedinRole && loggedinLocation) {
            fetchData();
        }
    }, [loggedinRole, loggedinLocation, schoolLocation, currentPage, itemsPerPage, searchTerm, searchClass, searchSection, searchQuarter, searchSession]);

    // console.log(fetchData)
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSearchClass = (event) => {
        setSearchClass(event.target.value.trim());
        setSearchSection(''); // Reset section when class changes
        setCurrentPage(1); // Reset current page to the first page
    };

    const handleSearchSection = (event) => {
        setSearchSection(event.target.value);
        setCurrentPage(1); // Reset current page to the first page
    };

    // console.log(searchSession)
    const handleSearchSession = (e) => {
        setSearchSession(e.target.value)
        setCurrentPage(1); // Reset current page to the first page
    }

    // console.log(searchQuarter)
    const handleSearchQuarter = (e) => {
        setSearchQuarter(e.target.value)
        setCurrentPage(1); // Reset current page to the first page
    }

    const handleRowsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset current page to the first page
    };

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const handlePageClick = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleEditClick = (rowData, quarterData) => {
        // Adjust 'selectedQuarter' to the actual quarter you're working with
        const selectedQuarter = rowData.quarters.find(q => q.quarter === quarterData.quarter);
        // setSelectedRow(rowData);
        setSelectedRow({
            ...rowData,
            // lexile: quarterData ? quarterData.lexile : '',
            // session: quarterData ? quarterData.session : '',
            // quarter: quarterData ? quarterData.quarter : '',
            // selected_paragraph: quarterData ? quarterData.selected_paragraph : ''
            lexile: selectedQuarter ? selectedQuarter.lexile : '',
            session: selectedQuarter ? selectedQuarter.session : '',
            quarter: selectedQuarter ? selectedQuarter.quarter : '',
            selected_paragraph: selectedQuarter ? selectedQuarter.selected_paragraph : ''
        });
        setShowModal(true);
    };


    // const handleEditClick = (rowData) => {
    //     // Iterate over each quarter and map it to a corresponding selectedRow object
    //     const selectedQuarters = rowData.quarters.map((quarter) => ({
    //         ...rowData,
    //         lexile: quarter.lexile,
    //         session: quarter.session,
    //         quarter: quarter.quarter,
    //         selected_paragraph: quarter.selected_paragraph
    //     }));

    //     // Now you have an array of selectedQuarters for each quarter
    //     // You can set this in the state or handle it as needed
    //     setSelectedRow(selectedQuarters[0]); // For example, selecting the first quarter to show in the modal
    //     setShowModal(true);
    // };



    const handleModalClose = () => {
        setShowModal(false);
        fetchData(); // Re-fetch data to ensure latest state
    };

    const handleSave = async (e, id) => {
        e.preventDefault(); // Prevent the default form submission behavior
        try {
            // const isDifferentQuarter = selectedRow.quarter !== fetcheddefaultQuarter || selectedRow.session !== fetcheddefaultSession;
            await axios.put(`${API}/upload/update-lexile/${id}`, {
                lexile: selectedRow.lexile || spokenWordsLength,
                session: fetcheddefaultSession,
                quarter: fetcheddefaultQuarter,
                selected_paragraph: selectedRow.selected_paragraph
                // selected_paragraph: isDifferentQuarter ? "" : selectedRow.selected_paragraph

            }, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
                .then((res) => {
                    // console.log(res)
                    // alert(res.data)
                    toast.success(res.data)
                    handleModalClose()
                })
                .catch((err) => {
                    console.log(err)
                    alert(err.response.data.message)
                });

            // Update the data state with the edited row data
            setData((prevData) =>
                prevData.map((item) => (item._id === selectedRow._id ? selectedRow : item))
            );


            // Close the modal
            // handleModalClose();
        } catch (error) {
            console.error('Error updating Lexile value:', error);
            alert(error.response.data.message)
        }
    };
    // console.log(data)

    const sortedData = [...data].sort((a, b) => {
        if (sortConfig.key) {
            // console.log(sortConfig.key)
            // console.log(sortConfig.direction)
            const aValue = sortConfig.key.split('.').reduce((o, k) => o[k], a);
            const bValue = sortConfig.key.split('.').reduce((o, k) => o[k], b);
            // console.log(aValue)
            // console.log(bValue)
            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        }
        return 0;
    });

    // working earlier properly without session and quarter 
    // const filteredData = sortedData.filter((item) =>
    //     item.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
    //     (searchClass ? item.class.toLowerCase() === searchClass.toLowerCase() : true) &&
    //     (searchSection ? item.section.toLowerCase() === searchSection.toLowerCase() : true) 

    // );

    // const filteredData = sortedData.filter((item) => {
    //     // Filter for name, class, and section (AND logic, same as original)
    //     const matchesName = item.name.toLowerCase().includes(searchTerm.toLowerCase());
    //     const matchesClass = searchClass ? item.class.toLowerCase() === searchClass.toLowerCase() : true;
    //     const matchesSection = searchSection ? item.section.toLowerCase() === searchSection.toLowerCase() : true;

    //     // console.log(item.quarters)
    //     // Filter for session and quarter (specific combination)
    //     const matchesQuarters = item.quarters.some((quarter) => {
    //         const matchedSession = searchSession
    //         ? quarter.session.trim().toLowerCase() === searchSession.trim().toLowerCase()
    //         : false;
    //       const matchedQuarter = searchQuarter
    //         ? quarter.quarter.trim().toLowerCase() === searchQuarter.trim().toLowerCase()
    //         : false;
    //         return matchedSession && matchedQuarter
    //     });

    //     // Combine: (name AND class AND section) OR quarters
    //     return (matchesName && matchesClass && matchesSection) || matchesQuarters;
    //   });


    // const filteredData = sortedData.filter((item) => {
    //     // Filter for name, class, and section
    //     const matchesName = item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ?? true;
    //     const matchesClass = searchClass ? item.class?.toLowerCase() === searchClass.toLowerCase() : true;
    //     const matchesSection = searchSection ? item.section?.toLowerCase() === searchSection.toLowerCase() : true;

    //     // Filter for session and quarter
    //     const matchesQuarters = (item.quarters?.length > 0) 
    //         ? item.quarters.some((quarter) => {
    //             const matchedSession = searchSession 
    //                 ? quarter.session?.trim().toLowerCase() === searchSession.trim().toLowerCase()
    //                 : true;
    //             const matchedQuarter = searchQuarter 
    //                 ? quarter.quarter?.trim().toLowerCase() === searchQuarter.trim().toLowerCase()
    //                 : true;
    //             return matchedSession && matchedQuarter;
    //         })
    //         : (!searchSession && !searchQuarter);  // If no quarters exist and no filters, show item

    //     return matchesName && matchesClass && matchesSection && matchesQuarters;
    // });



    //============================= get default values start =================================

    // -----------fetch default session data start -----------
    const [fetcheddefaultSession, setfetcheddefaultSession] = useState("")
    useEffect(() => {
        axios.get(`${API}/default-session/66c44d078b84a11874513d8c`)
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetcheddefaultSession(res.data.data.default_session)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    // -----------fetch default session data end -----------



    // -----------fetch default quarter data start -----------
    const [fetcheddefaultQuarter, setfetcheddefaultQuarter] = useState("")
    useEffect(() => {
        axios.get(`${API}/default-quarter/66c454ba55b891fa6685b020`)
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetcheddefaultQuarter(res.data.data.default_Quarter)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    // -----------fetch default quarter data end -----------

    //============================= get default values end =================================





    // Filter the data
    const filteredData = sortedData
        .map(item => {
            // Filter for name, class, and section
            const matchesName = item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ?? true;
            const matchesClass = searchClass ? item.class?.toLowerCase() === searchClass.toLowerCase() : true;
            const matchesSection = searchSection ? item.section?.toLowerCase() === searchSection.toLowerCase() : true;
            // const matchesSession = fetcheddefaultSession ? item.academic_session?.trim().toLowerCase() === fetcheddefaultSession.trim().toLowerCase() : true;
            const matchesSession = loggedinRole === "Super Admin"
                ? (searchSession ? item.academic_session?.trim().toLowerCase() === searchSession.trim().toLowerCase() : true)
                : (fetcheddefaultSession ? item.academic_session?.trim().toLowerCase() === fetcheddefaultSession.trim().toLowerCase() : true);
            // console.log(matchesSession)
            // console.log(item.academic_session)
            // console.log(searchSession)

            // Filter quarters based on session and quarter
            const filteredQuarters = item.quarters?.filter((quarter) => {
                // const matchedSession = searchSession
                //     ? quarter.session?.trim().toLowerCase() === searchSession.trim().toLowerCase()
                //     : true;
                const matchedQuarter = searchQuarter
                    ? quarter.quarter?.trim().toLowerCase() === searchQuarter.trim().toLowerCase()
                    : true;
                // return matchedSession &&  matchedQuarter;
                return matchedQuarter;
            }) || [];

            // Only include items that have matching quarters and match other criteria
            // const matchesQuarters = filteredQuarters.length > 0 || (!searchSession && !searchQuarter);
            const matchesQuarters = filteredQuarters.length > 0 || (!searchQuarter && item.academic_session?.trim().toLowerCase() === fetcheddefaultSession.trim().toLowerCase());


            // console.log("matchesName:", matchesName);
            // console.log("matchesClass:", matchesClass);
            // console.log("matchesSection:", matchesSection);
            // console.log("matchesQuarters:", matchesQuarters);
            // console.log("filteredQuarters:", filteredQuarters);

            if (matchesName && matchesClass && matchesSection && matchesSession && matchesQuarters) {
                return {
                    ...item,
                    quarters: filteredQuarters.length > 0 ? filteredQuarters : item.quarters
                };
            }
            return null;
        })
        .filter(item => item !== null);


    // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    // const currentData = filteredData.slice(startIndex, endIndex);
    // const currentData = filteredData // Already paginated from backend
    const currentData = data // Already paginated from backend
    // console.log(totalCount)
    // console.log(totalPages)



    // =====================================showmodal question start ====================================

    // console.log(paragraphName.paragraph_details)


    // get all paragraph name start 
    useEffect(() => {
        axios.get(`${API}/add-paragraph/get-paragraph`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setparagraphName(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    // get all paragraph name end

    const handleUpdateQuestion = (rowData) => {
        setSelectedRow(rowData);
        setshowModalQuestions(true);
    }

    // -------------show paragraph question start --------------

    // -------------get all question data start ----------------
    const [get_allQuestion, setget_allQuestion] = useState([])
    const [yesCount, setYesCount] = useState(0); // State to store the count of "Yes"
    const [lexile_message, setLexile_message] = useState("");
    const [lexile_color, setLexile_color] = useState("#C8C8C8");
    const [lexile_condition, setLexile_condition] = useState();
    // console.log(get_allQuestion)
    // console.log(yesCount)


    useEffect(() => {
        axios.get(`${API}/question/get-student-ques`, {
            headers: {
                "Content-Type": "application/josn",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }

        })
            .then((res) => {
                // console.log(res.data.data)
                setget_allQuestion(res.data.data)

                // count total yes 
                // const allDataFromQuestion = res.data.data
                // const countYes = allDataFromQuestion.filter(question => question.student_answer === "Yes").length;
                // setYesCount(countYes);
                // // calculate lexile start
                // // let lexile_condition = 0

                // if (yesCount === 4 || yesCount === 3) {
                //     setLexile_message("Reading needs urgent attention")
                //     setLexile_color("#F48C5E")
                //     setLexile_condition(50 / 100)
                // } else if (yesCount === 5 || yesCount === 6) {
                //     setLexile_message("Reading needs improvement")
                //     setLexile_color("#FFCCFF")
                //     setLexile_condition(75 / 100)
                // } else if (yesCount === 7) {
                //     setLexile_message("Good Reader")
                //     setLexile_color("#D5EAFF")
                //     setLexile_condition(100 / 100)
                // } else if (yesCount === 8 && yesCount === 9) {
                //     setLexile_message("Very Good Reader")
                //     setLexile_color("#FFFF99")
                //     setLexile_condition(125 / 100)
                // } else if (yesCount === 10) {
                //     setLexile_message("Outstanding Reader")
                //     setLexile_color("#99FF66")
                //     setLexile_condition(150 / 100)
                // } else {
                //     setLexile_message("Invalid Count")
                //     setLexile_color("#C8C8C8")

                // }
                // calculate lexile end
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)
            })
    }, [updateTable])
    // -------------get all question data end ----------------

    // -------------show paragraph question end --------------



    //------------- operation on toggle start --------------------
    const [totalYesCount, setTotalYesCount] = useState({});

    // Toggle handler with API update
    // const handleToggle = async (itemId, currentAnswer) => {
    //     const newAnswer = currentAnswer === 'No' ? 'Yes' : 'No';

    //     try {
    //         // Update local state
    //         setget_allQuestion(prevQuestions =>
    //             prevQuestions.map(item =>
    //                 item._id === itemId ? { ...item, student_answer: newAnswer } : item
    //             )
    //         );

    //         // Update backend
    //         await axios.patch(`${API}/question/${itemId}`, { student_answer: newAnswer });
    //         setUpdateTable(prev => !prev); // Trigger a re-fetch
    //     } catch (error) {
    //         console.error('Error updating student_answer:', error);
    //         alert('Failed to update');
    //     }
    // };
    // const handleToggle = async (itemId, currentAnswer, studentId) => {
    //     const newAnswer = currentAnswer === 'Yes' ? 'No' : 'Yes';

    //     try {
    //         // Update local state
    //         setget_allQuestion(prevQuestions =>
    //             prevQuestions.map(item =>
    //                 item._id === itemId ? {
    //                     ...item,
    //                     student_answer: {
    //                         ...item.student_answer,
    //                         [studentId]: newAnswer
    //                     }
    //                 } : item
    //             )
    //         );

    //         // Update backend
    //         await axios.patch(`${API}/question/${itemId}`, {
    //             studentId,
    //             student_answer: newAnswer
    //         });




    //         // Count total "Yes" after update
    //         const updatedQuestions = get_allQuestion.map(item =>
    //             item._id === itemId ? { ...item, student_answer: newAnswer } : item
    //         );
    //         const countYes = updatedQuestions.filter(question => question.student_answer === "Yes").length;
    //         setYesCount(countYes);

    //         // Recalculate lexile_condition
    //         if (countYes === 4 || countYes === 3) {
    //             setLexile_message("Reading needs urgent attention");
    //             setLexile_color("#F48C5E");
    //             setLexile_condition(50 / 100);
    //         } else if (countYes === 5 || countYes === 6) {
    //             setLexile_message("Reading needs improvement");
    //             setLexile_color("#FFCCFF");
    //             setLexile_condition(75 / 100);
    //         } else if (countYes === 7) {
    //             setLexile_message("Good Reader");
    //             setLexile_color("#D5EAFF");
    //             setLexile_condition(100 / 100);
    //         } else if (countYes === 8 || countYes === 9) {
    //             setLexile_message("Very Good Reader");
    //             setLexile_color("#FFFF99");
    //             setLexile_condition(125 / 100);
    //         } else if (countYes === 10) {
    //             setLexile_message("Outstanding Reader");
    //             setLexile_color("#99FF66");
    //             setLexile_condition(150 / 100);
    //         } else {
    //             setLexile_message("Invalid Count");
    //             setLexile_color("#C8C8C8");
    //         }






    //         setUpdateTable(prev => !prev); // Trigger a re-fetch
    //     } catch (error) {
    //         console.error('Error updating student_answer:', error);
    //         alert('Failed to update');
    //     }
    // };
    // const handleToggle = async (itemId, currentAnswer, studentId) => {
    //     const newAnswer = currentAnswer === 'Yes' ? 'No' : 'Yes';

    //     try {
    //         // Update local state with a callback to ensure state is updated properly
    //         setget_allQuestion(prevQuestions => {
    //             const updatedQuestions = prevQuestions.map(item =>
    //                 item._id === itemId ? {
    //                     ...item,
    //                     student_answer: {
    //                         ...item.student_answer,
    //                         [studentId]: newAnswer
    //                     }
    //                 } : item
    //             );

    //             // // Count total "Yes" after update
    //             // const countYes = updatedQuestions.reduce((count, question) => {
    //             //     return count + (Object.values(question.student_answer).filter(answer => answer === 'Yes').length);
    //             // }, 0);

    //             // setYesCount(countYes);

    //             // // Recalculate lexile_condition
    //             // if (countYes === 4 || countYes === 3) {
    //             //     setLexile_message("Reading needs urgent attention");
    //             //     setLexile_color("#F48C5E");
    //             //     setLexile_condition(50 / 100);
    //             // } else if (countYes === 5 || countYes === 6) {
    //             //     setLexile_message("Reading needs improvement");
    //             //     setLexile_color("#FFCCFF");
    //             //     setLexile_condition(75 / 100);
    //             // } else if (countYes === 7) {
    //             //     setLexile_message("Good Reader");
    //             //     setLexile_color("#D5EAFF");
    //             //     setLexile_condition(100 / 100);
    //             // } else if (countYes === 8 || countYes === 9) {
    //             //     setLexile_message("Very Good Reader");
    //             //     setLexile_color("#FFFF99");
    //             //     setLexile_condition(125 / 100);
    //             // } else if (countYes === 10) {
    //             //     setLexile_message("Outstanding Reader");
    //             //     setLexile_color("#99FF66");
    //             //     setLexile_condition(150 / 100);
    //             // } else {
    //             //     setLexile_message("Invalid Count");
    //             //     setLexile_color("#C8C8C8");
    //             // }

    //             return updatedQuestions;
    //         });

    //         // Update backend
    //         await axios.patch(`${API}/question/${itemId}`, {
    //             studentId,
    //             student_answer: newAnswer
    //         });
    //     } catch (error) {
    //         console.error('Error updating student_answer:', error);
    //         alert('Failed to update');
    //     }
    // };


    // working function on 08-30-2024 start 
    // const handleToggle = async (itemId, currentAnswer, studentId, quarter, session) => {
    //     const newAnswer = currentAnswer === 'Yes' ? 'No' : 'Yes';

    //     try {
    //         // Update local state with a callback to ensure state is updated properly
    //         setget_allQuestion(prevQuestions => {
    //             const updatedQuestions = prevQuestions.map(item =>
    //                 item._id === itemId ? {
    //                     ...item,
    //                     student_answer: {
    //                         ...item.student_answer,
    //                         [studentId]: newAnswer
    //                     }
    //                 } : item
    //             );

    //             // // Calculate the total "Yes" answers
    //             // console.log(updatedQuestions)
    //             // const newTotalYesCount = updatedQuestions.reduce((total, question) => {
    //             //     return total + Object.values(question.student_answer).filter(answer => answer === 'Yes').length;
    //             // }, 0);
    //             // setTotalYesCount(newTotalYesCount);



    //             return updatedQuestions;
    //         });

    //         // Update backend
    //         await axios.patch(`${API}/question/${itemId}`, {
    //             studentId,
    //             student_answer: newAnswer,
    //             quarter,   // Send the quarter
    //             session    // Send the session
    //         });

    //     } catch (error) {
    //         console.error('Error updating student_answer:', error);
    //         alert(error.response.data.message);
    //     }
    // };
    // working function on 08-30-2024 end 

    // practising funtin on 08-30-2024 start 
    const handleToggle = async (itemId, currentAnswer, studentId, quarter, session) => {
        const newAnswer = currentAnswer === 'Yes' ? 'No' : 'Yes';
        const previousAnswer = currentAnswer; // Store the previous answer

        try {
            // Optimistically update local state
            setget_allQuestion(prevQuestions => {
                return prevQuestions.map(item =>
                    item._id === itemId ? {
                        ...item,
                        student_answer: {
                            ...item.student_answer,
                            [studentId]: newAnswer
                        }
                    } : item
                );
            });



            // Attempt to update the backend
            await axios.patch(`${API}/question/${itemId}`, {
                studentId,
                student_answer: newAnswer,
                quarter,   // Send the quarter
                session    // Send the session
            });

        } catch (error) {
            console.error('Error updating student_answer:', error);
            alert(error.response.data.message);

            // Revert state back to the previous answer if the backend update fails
            setget_allQuestion(prevQuestions => {
                return prevQuestions.map(item =>
                    item._id === itemId ? {
                        ...item,
                        student_answer: {
                            ...item.student_answer,
                            [studentId]: previousAnswer
                        }
                    } : item
                );
            });
        }
    };





    // const [totalYesCount, setTotalYesCount] = useState(0);

    useEffect(() => {
        if (selectedRow?._id) {
            const countYesAnswers = () => {
                let yesCount = 0;

                // Assuming you have a selectedQuarter variable to determine the current quarter
                // const selectedQuarter = "1"; // Replace this with your logic to get the current quarter (e.g., from state or props)

                // console.log(selectedRow)
                // console.log(get_allQuestion)

                // Loop through the questions
                get_allQuestion
                    .filter((item) => item.paragraph_id.paragraph_name === selectedRow.selected_paragraph) // Only include questions from the selected quarter
                    .forEach((item) => {

                        const answer = item.student_answer[selectedRow._id];
                        if (answer === "Yes") {
                            yesCount++;

                        }
                    });

                setTotalYesCount(yesCount);
            };

            countYesAnswers();
        } else {
            setTotalYesCount(0); // Reset if no student is selected
        }
    }, [get_allQuestion, selectedRow?._id]);




    // practising funtin on 08-30-2024 end


    // get total answer start 
    const getTotalYesAnswers = (studentId, paragraphId) => {
        let totalYes = 0;

        get_allQuestion.forEach(item => {
            if (item.paragraph_id === paragraphId && item.student_answer[studentId] === "Yes") {
                totalYes++;
            }
        });

        return totalYes;
    };
    // get total answer end




    //------------- operation on toggle end --------------------


    // =====================================showmodal question end ====================================


    //======================get quarter start =====================================
    //-------- get all quarter data start -------------
    const [quarterData, setquarterData] = useState([])
    useEffect(() => {
        axios.get(`${API}/quarter`)
            .then((res) => {
                // console.log(res)
                setquarterData(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //-------- get all quarter data end -------------
    //======================get quarter end =====================================


    // ========================get all session data start =============================
    // ---------get all session data start ----------
    const [allsessiondata, setallsessiondata] = useState([])
    // console.log(allsessiondata)
    useEffect(() => {
        axios.get(`${API}/session`)
            .then((res) => {
                // console.log(res.data.data)
                setallsessiondata(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //----------- get all session data end-----------
    // ========================get all session data end =============================




    // console.log(filteredData)


    //========================= operation on remarks start ==================================
    const [remarksModal, setremarksModal] = useState(false)
    const [remarksID, setremarksID] = useState("")
    const [getRemarks, setgetRemarks] = useState("")

    const handleRemarks = async (id) => {
        setremarksModal(true)
        setremarksID(id)

        await axios.get(`${API}/upload/get-remarks/${id}`)
            .then((res) => {
                // console.log(res.data.data.remarks)
                setgetRemarks(res.data.data.remarks)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.error)
            })
    }


    const handleModalRemarksClose = () => {
        setremarksModal(false)
    }

    const updateRemarks = async (id) => {
        const data = {
            remarks: getRemarks
        }
        await axios.put(`${API}/upload/update-remarks/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                handleModalRemarksClose()
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.error)
            })
    }
    //========================= operation on remarks end ==================================



    //======================= operation on speech recognition start ======================
    // speech recognition start 
    //   const [paragraph, setParagraph] = useState("This is the read paragraph for the user to read paragraph for the user to .");

    // console.log(paragraph)


    //---------- it was uncommented before i was working on 12-10-2024 start -------
    // useEffect(() => {
    //     // Compare the transcript with the paragraph and highlight matched text
    //     // Compare the transcript with the paragraph and highlight matched and mispronounced words
    //     const spoken = transcript.trim().split(" ");  // Remove leading/trailing spaces and split words
    //     const wordsInParagraph = paragraph.trim().split(" ");
    //     // console.log("w3e are here1")

    //     const highlighted = wordsInParagraph.map((word, index) => {
    //         // console.log("w3e are here1")
    //         if (spoken[index]) {
    //             if (word.toLowerCase() === spoken[index].toLowerCase()) {
    //                 // Correct word (green)
    //                 return `<span style="color: green; font-weight:700">${word}</span>`;
    //             } else {
    //                 // Mispronounced word (red)
    //                 return `<span style="color: red;font-weight:700">${word}</span>`;
    //             }
    //         }
    //         // Words not yet spoken remain default
    //         return word;
    //     });
    //     setSpokenWords(highlighted.join(" "));
    // }, [transcript, paragraph]);
    //---------- it was uncommented before i was working on 12-10-2024 end -------

    // This function updates the paragraph with color changes based on what was read

    // useEffect(() => {
    //     const words = paragraph.split(" ");
    //     const transcriptWords = transcript.split(" ");
    //     let updatedText = "";

    //     words.forEach((word, index) => {
    //         if (transcriptWords[index] && transcriptWords[index].toLowerCase() === word.toLowerCase()) {
    //             updatedText += `<span style="color:green">${word} </span>`;
    //         } else if (transcriptWords[index]) {
    //             updatedText += `<span style="color:red">${word} </span>`;
    //         } else {
    //             updatedText += `<span>${word} </span>`;
    //         }
    //     });

    //     setDisplayText(updatedText); // Update the display text
    // }, [transcript, paragraph]);

    if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
        return <div>Your browser does not support speech recognition.</div>;
    }
    const startListening = () => {
        SpeechRecognition.startListening({ continuous: true });
    };

    const stopListening = () => {
        SpeechRecognition.stopListening();
    };


    // speech recognition end
    //======================= operation on speech recognition end ======================






    // =======================operation on building timer start ===========================


    // const handleTimer = () => {
    //     if (timerIntervalRef.current !== null) return; // Prevent multiple intervals

    //     SpeechRecognition.startListening({continuous:true,language:"en-IN" });

    //     timerIntervalRef.current = setInterval(() => {
    //         settimerSec((prevTime) => {
    //             if (prevTime === 0) {
    //                 clearInterval(timerIntervalRef.current)
    //                 timerIntervalRef.current = null; // Reset interval reference
    //                 // Stop speech recognition when timer ends
    //                 SpeechRecognition.stopListening();

    //                 settimerMessage(true)
    //                 console.log("Countdown complete")
    //                 return 0;
    //             } else {
    //                 return prevTime - 1;
    //             }
    //         })
    //     }, 1000);
    // }

    // ------working code earlier start ----------------
    // const handleTimer = () => {
    //     if (timerIntervalRef.current !== null) return; // Prevent multiple intervals

    //     SpeechRecognition.startListening({ continuous: true, language: "en-IN" });

    //     timerIntervalRef.current = setInterval(() => {
    //         settimerSec((prevTime) => {
    //             if (prevTime === 0) {
    //                 clearInterval(timerIntervalRef.current);
    //                 timerIntervalRef.current = null; // Reset interval reference
    //                 SpeechRecognition.stopListening();
    //                 settimerMessage(true);
    //                 console.log("Countdown complete");
    //                 return 0;
    //             }
    //             return prevTime - 1;
    //         });
    //     }, 1000);
    // };
    // ------working code earlier end ----------------


    //------ copilot code start ----------------
    const handleTimer = () => {
        if (timerIntervalRef.current !== null) return; // Prevent multiple intervals

        // Reset the input field to 0 when the timer starts
        setSpokenWordsLength(0);
        setSelectedRow((prev) => ({ ...prev, lexile: 0 }));

        // to start speech recognition
        // SpeechRecognition.startListening({ continuous: true, language: "en-IN" });

        timerIntervalRef.current = setInterval(() => {
            settimerSec((prevTime) => {
                if (prevTime === 0) {
                    clearInterval(timerIntervalRef.current);
                    timerIntervalRef.current = null; // Reset interval reference
                    SpeechRecognition.stopListening();
                    settimerMessage(true);
                    console.log("Countdown complete");

                    // Fetch the lexile value and display it in the input field
                    setSpokenWordsLength(selectedRow.lexile);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
    };

    //------ copilot code end ----------------



    const handleResetTimer = () => {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null; // Reset interval reference
        settimerSec(initialTime); // Reset timer to initial value
        setSpokenWords([]); // Clear spoken words
        SpeechRecognition.stopListening()
        resetTranscript()
        settimerMessage(false)
    }

    // const handleTimer = () => {
    //     if (timerIntervalRef.current !== null) return; // Prevent multiple intervals

    //     SpeechRecognition.startListening({ continuous: true, language: "en-IN" });

    //     timerIntervalRef.current = setInterval(() => {
    //         settimerSec((prevTime) => {
    //             if (prevTime === 0) {
    //                 clearInterval(timerIntervalRef.current);
    //                 timerIntervalRef.current = null; // Reset interval reference
    //                 SpeechRecognition.stopListening();

    //                 settimerMessage(true);
    //                 console.log("Countdown complete");
    //                 return 0;
    //             } else {
    //                 return prevTime - 1;
    //             }
    //         });
    //     }, 1000);
    // };

    // const handleResetTimer = () => {
    //     clearInterval(timerIntervalRef.current);
    //     timerIntervalRef.current = null; // Reset interval reference
    //     settimerSec(59); // Reset timer to initial value
    //     resetTranscript();
    //     settimerMessage(false);
    //     setSpokenWords([]); // Clear spoken words
    // };





    const handleReportCard = async (id) => {
        try {
            setshowReportCard(true)
            await axios.get(`${API}/report/get-report/${id}`, {
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
                .then((res) => {
                    // console.log(res)
                    setreportaverageLexile(res.data.averageLexile)
                    setreportName(res.data.data.name)
                    setreportClass(res.data.data.class)
                    setreportData(res.data.data.quarters)
                })
                .catch((err) => {
                    console.log(err)
                })

        } catch (error) {

        }
    }
    // =========================operation on report card end=============================


    //============= ============find user role and give permission start ============================


    //============= ============find user role and give permission end ============================





    //============================ print functionality start ====================================
    // const componentRef = useRef();

    // --------print functionality start -------------
    // const handlePrint = () => {
    //     const printContents = document.getElementById(`printable`).innerHTML;
    //     const printWindow = window.open('', '', 'height=600,width=800');
    //     printWindow.document.write('<html><head><title>Lexile Report Card</title>');
    //     // printWindow.document.write('<style>@media print { body * { visibility: hidden; } .printable button, .printable #button * {visibility:hidden;} .printable * { visibility: visible; } .printable img { display: block; margin-left: auto; margin-right: auto;} .printable{border:2px; border-color:red;}} .printable h1 { text-align:center} .printable br {visibility:hidden} @page { margin: 0; } footer { display: none; } .printable p { margin: 0; padding: 0; }</style>');
    //     printWindow.document.write('<style>@media print { body * { visibility: hidden; } .printable button, .printable #button * {visibility:hidden;} .printable * { visibility: visible; } .printable img { display: block; margin-left: auto; margin-right: auto;} .printable{border:2px; border-color:red;}} .printable h1 { text-align:center} .printable br {visibility:hidden} @page { margin: 10px; padding:3px; } footer { display: none; } .printable p { margin: 0; padding: 0; }</style>');
    //     printWindow.document.write('</head><body>');
    //     printWindow.document.write(`<div class="printable">${printContents}</div>`);
    //     printWindow.document.write('</body></html>');
    //     printWindow.document.close();
    //     printWindow.print();
    // };


    const handlePrint = () => {
        const printContents = document.getElementById(`printable`).innerHTML;
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Student Literacy Growth Tracker</title>');

        // Add styles for printing
        printWindow.document.write(`
            <style>
                @media print {
                    body * {
                        visibility: hidden;
                        
                    }
                    .printable, .printable * {
                        visibility: visible;
                    }
                    .printable {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        // border: 2px solid red;
                        box-sizing: border-box;
                        
                    }
                    .printable button, .printable #button, .printable #button * {
                        display:none;
                    }
                    .printable .logo {
                         display:flex;
                         justify-content:center;
                         margin-left: auto;
                         margin-right: auto;
                    }
                    .printable img {
                        display: block;
                        width: 80%;
                        max-height: 120px;
                        object-fit: contain;
                    }
                    .printable br[id="button"] {
                        visibility: hidden;
                    }
                    @page {
                       margin:10px 75px 10px 75px;
                        padding: 5px;
                    }
                    footer {
                        display: none;
                    }
                }
                .printable h1, .printable h2 {
                    text-align: center;
                }
                .printable p {
                    margin: 0;
                    padding: 0;
                }
                .printable .report-table {
                    width: 100%;
                    display:flex;
                    justify-content:center;
                }
                .printable table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .printable th, .printable td {
                    border: 2px solid black;
                    padding: 8px;
                    text-align: center;
                }
                .printable .bg-gray-200 {
                    background-color: #e5e7eb;
                }
                .printable .bg-gray-100 {
                    background-color: #f3f4f6;
                }
                .printable .text-center {
                    text-align: center;
                }
                .printable .border-2 {
                    border-width: 1px;
                }
                .printable .border-black {
                    border-color: black;
                }
                .printable .p-2 {
                    padding: 8px;
                }
                .printable .margin_top {
                    margin-top:80px
                }
                .printable .py-\[10px\] {
                    padding-top: 10px;
                    padding-bottom: 10px;
                }
                .printable .flex {
                    display: flex;
                }
                .printable .flex-col {
                    flex-direction: column;
                }
                .printable .justify-center {
                    justify-content: center;
                }
                .printable .items-center {
                    align-items: center;
                }
                .printable .gappppp {
                    gap: 150px;
                }
                .printable .mt-2 {
                    margin-top: 8px;
                }
                .printable .text-\[22px\] {
                    font-size: 22px;
                }
                .printable .font-semibold {
                    font-weight: 600;
                }
                .printable .w-\[80\%\] {
                    width: 80%;
                }
                .printable .note {
                    width: 200px;
                }
                .printable .max-h-\[120px\] {
                    max-height: 120px;
                }
                .printable .object-contain {
                    object-fit: contain;
                }
                .printable .border-dotted {
                    border-style: dotted;
                }
            </style>
        `);

        printWindow.document.write('</head><body>');
        printWindow.document.write(`<div class="printable">${printContents}</div>`);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    };




    return (
        <div className='container '>
            <ToastContainer autoClose={2000} position='top-right' />
            <div className='flex flex-wrap gap-2 sm:gap-5 justify-center sm:justify-between'>

                <div>
                    <h1 className='text-[15px] font-semibold'>Current session:{fetcheddefaultSession}, Quarter:{fetcheddefaultQuarter}</h1>
                </div>



                {
                    loggedinRole && loggedinRole === "Super Admin" ? (

                        <div className='search-bar'>
                            <div className="search-wrapper">
                                <select
                                    // value={schoolLocation}
                                    value={loggedinRole === "Super Admin" ? `${schoolLocation}` : `${loggedinLocation}`}
                                    onChange={(e) => setschoolLocation(e.target.value)}
                                    className='search-input'
                                >
                                    <option value="">Select Location</option>
                                    {
                                        allLocationData && allLocationData.map((item, index) => {
                                            return (
                                                <option key={index} value={item.name.trim()}>{item.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    ) : null
                }


                <div className='flex flex-wrap gap-5 justify-center sm:justify-end'>
                    <div>
                        <a href={teacher} target='blank'>
                            <button className='bg-black text-white text-[12px] sm:text-[15px] px-[3px] py-[2px] sm:px-[10px] sm:py-[5px]'>Teacher Guide</button>
                        </a>
                    </div>
                    {
                        loggedinRole && loggedinRole === "Admin" || loggedinRole === "Super Admin" ? (
                            <div>
                                <a href={admin} target='blank'>
                                    <button className='bg-black text-white text-[12px] sm:text-[15px] px-[3px] py-[2px] sm:px-[10px] sm:py-[5px]'>Admin Guide</button>
                                </a>
                            </div>
                        ) : null
                    }

                    <div>
                        <button onClick={() => setShowRubric(true)} className='bg-black text-white text-[12px] sm:text-[15px] px-[3px] py-[2px] sm:px-[10px] sm:py-[5px]'>Show Rubric</button>
                    </div>

                    <div>
                        <DownloadTableExcel
                            filename="users table"
                            sheet="users"
                            // currentTableRef={tableRef.current}
                            currentTableRef={exportTableRef.current}  // Reference to the hidden table
                        >

                            <button className='bg-black text-white text-[12px] sm:text-[15px] px-[3px] py-[2px] sm:px-[10px] sm:py-[5px]'> Export excel </button>

                        </DownloadTableExcel>
                    </div>
                </div>
            </div>



            <div className='flex items-center gap-3 flex-wrap'>
                <div className='search-bar'>
                    <div className="search-wrapper">
                        <input
                            type="text"
                            placeholder="Search by name"
                            value={searchTerm}
                            onChange={handleSearch}
                            className='search-input'
                        />
                        <i className="search-icon fas fa-search"></i>
                    </div>
                </div>

                <div className='search-bar'>
                    <div className="search-wrapper">
                        <select
                            value={searchClass}
                            onChange={handleSearchClass}
                            className='search-input'
                        >
                            <option value="">Select Class</option>
                            {Object.keys(classSections).map((cls) => (
                                <option key={cls} value={cls}>{cls}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className='search-bar '>
                    <div className={`search-wrapper  ${!searchClass ? "-z-10" : ""}`}>
                        <select
                            value={searchSection}
                            onChange={handleSearchSection}
                            className='search-input'
                            disabled={!searchClass}
                        >
                            <option value="">Select Section</option>
                            {searchClass && classSections[searchClass].map((section) => (
                                <option key={section} value={section}>{section}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className='flex'>
                    {/* <h1 className='text-[15px] font-semibold'>Current session:{fetcheddefaultSession}, Quarter:{fetcheddefaultQuarter}</h1> */}
                    <div className='search-bar '>
                        {/* <h1>Current session:</h1> */}
                        <select
                            // disabled={true}
                            //disable the session dropdown for non super admin users
                            // disabled={loggedinRole !== "Super Admin" }
                            //disable the session dropdown for non super admin and admin users
                            disabled={loggedinRole !== "Super Admin" && loggedinRole !== "Admin"}
                            // value={fetcheddefaultSession}
                            //value for super admin and default value for other users
                            // value={loggedinRole === "Super Admin" ? searchSession : fetcheddefaultSession}
                            // value for super admin and admin and default value for other users
                            value={loggedinRole === "Super Admin" || loggedinRole === "Admin" ? searchSession : fetcheddefaultSession}
                            // onChange={handleSearchSession}
                            //handle change only for super admin users
                            // onChange={loggedinRole === "Super Admin" ? handleSearchSession : undefined}
                            //handle change only for super admin and admin users
                            onChange={loggedinRole === "Super Admin" || loggedinRole === "Admin" ? handleSearchSession : undefined}
                            className=' border-[1px] border-[#6c7ae0] px-[4px] py-[4px] text-[12px] w-[100px] rounded-full mr-[10px]'
                        >
                            <option value="">Select Session</option>
                            {
                                allsessiondata && allsessiondata.map((item, index) => {
                                    return (

                                        <option key={index} value={item.name}>{item.name}</option>

                                    )
                                })
                            }
                        </select>
                    </div>

                    <div className='search-bar '>
                        {/* <h1>Current quarter:</h1> */}
                        <select value={searchQuarter} onChange={handleSearchQuarter} className='border-[1px] border-[#6c7ae0] px-[6px] py-[4px] text-[12px] w-[100px] rounded-full'>
                            <option value="">Select Quarter</option>
                            {
                                quarterData && quarterData.map((item, index) => {
                                    return (
                                        <option key={index} value={item.name}>{item.name}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
            </div>


            <div className="pagination-options">
                <div className="rows-per-page">
                    Rows per page:
                    <select value={itemsPerPage} onChange={handleRowsPerPageChange}>
                        {rowsPerPageOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>

                <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    handlePageClick={handlePageClick}
                />

            </div>



            {/* <table className="table">
                <thead>
                    <tr>
                        <th onClick={() => handleSort('erpId')}>ERPID</th>
                        <th className='w-[100px]'>Session</th>
                        <th >Quarter</th>
                        <th onClick={() => handleSort('name')}>Name</th>
                        <th className='w-[150px]' onClick={() => handleSort('class')}>Class</th>
                        <th onClick={() => handleSort('section')}>Section</th>
                       
                        <th onClick={() => handleSort('lexile')}>Reading rate(wpm)</th>
                        <th >Lexile Score</th>
                        <th >Reader</th>

                        <th className='w-[150px]' >Update</th>
                       
                    </tr>
                </thead>
                <tbody>
                    {currentData.map((item, index) => {
                        let bgColor = "";
                        if (item.reader_message === "Reading needs urgent attention") {
                            bgColor = "#F48C5E";
                        } else if (item.reader_message === "Reading needs improvement") {
                            bgColor = "#FFCCFF";
                        } else if (item.reader_message === "Good Reader") {
                            bgColor = "#D5EAFF";
                        } else if (item.reader_message === "Very Good Reader") {
                            bgColor = "#FFFF99";
                        } else if (item.reader_message === "Outstanding Reader") {
                            bgColor = "#99FF66";
                        } else {
                            bgColor = "#C8C8C8";
                        }

                        return (
                            <tr key={item._id}>
                                <td>{item.erpId}</td>
                                <td>{item.session}</td>
                                <td>{item.quarter}</td>
                                <td>{item.name}</td>
                                <td>{item.class}</td>
                                <td>{item.section}</td>
                              
                                <td>{item.lexile}</td>
                               
                                <td>{item.lexile_score}</td> 
                                <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{item.reader_message} </td>
                                <td>

                                    <button className='' onClick={() => handleEditClick(item)}>Evaluate</button>
                                </td>
                               

                            </tr>
                        )
                    }

                    )}
                </tbody>
            </table> */}
            <div className='table_container'>
                <table className="table mt-[10px]" ref={tableRef}>
                    <thead>
                        <tr>
                            {/* <th>#</th> */}
                            <th className='w-[50px]' onClick={() => handleSort('erpId')}>Student ID</th>
                            <th className='w-[100px]'>Session</th>
                            <th>Quarter</th>
                            <th onClick={() => handleSort('name')}>Name</th>
                            <th className='w-[150px]' onClick={() => handleSort('class')}>Class</th>
                            <th onClick={() => handleSort('section')}>Section</th>
                            <th>Reading rate (wpm)</th>
                            <th>Lexile Score</th>
                            <th>Reader</th>
                            <th>Paragraph Name</th>
                            <th className='w-[100px]'>Evaluate</th>
                            <th className='w-[70px]'>Remarks</th>
                            {/* <th className='w-[50px]'>Report Card</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {/* {currentData.map((item, index) => {
                        let bgColor = "";
                        if (item.reader_message === "Reading needs urgent attention") {
                            bgColor = "#F48C5E";
                        } else if (item.reader_message === "Reading needs improvement") {
                            bgColor = "#FFCCFF";
                        } else if (item.reader_message === "Good Reader") {
                            bgColor = "#D5EAFF";
                        } else if (item.reader_message === "Very Good Reader") {
                            bgColor = "#FFFF99";
                        } else if (item.reader_message === "Outstanding Reader") {
                            bgColor = "#99FF66";
                        } else {
                            bgColor = "#C8C8C8";
                        }

                        // Check if the student has quarter data
                        if (item.quarters && item.quarters.length > 0) {
                            return item.quarters.map((quarterData, qIndex) => (
                                <tr key={`${item._id}-${qIndex}`}>
                                    <td>{item.erpId}</td>
                                    <td>{quarterData.session}</td>
                                    <td>{quarterData.quarter}</td>
                                    <td>{item.name}</td>
                                    <td>{item.class}</td>
                                    <td>{item.section}</td>
                                    <td>{quarterData.lexile}</td>
                                    <td>{quarterData.lexile_score}</td>
                                    <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{quarterData.reader_message}</td>
                                    <td>
                                        <button className='' onClick={() => handleEditClick(item, quarterData)}>Evaluate</button>
                                    </td>
                                </tr>
                            ));
                        } else {
                            // Display row without quarter data
                            return (
                                <tr key={item._id}>
                                    <td>{item.erpId}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{item.name}</td>
                                    <td>{item.class}</td>
                                    <td>{item.section}</td>
                                    <td>-</td>
                                    <td>{item.lexile_score}</td>
                                    <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{item.reader_message}</td>
                                    <td>
                                        <button className='' onClick={() => handleEditClick(item, null)}>Evaluate</button>
                                    </td>
                                </tr>
                            );
                        }
                    })} */}
                        {currentData.map((item, index) => {
                            // Check if the student has quarter data
                            if (item.quarters && item.quarters.length > 0) {
                                return item.quarters.map((quarterData, qIndex) => {
                                    let bgColor = "";
                                    if (quarterData.reader_message === "Reading to be Prioritized") {
                                        bgColor = "#F48C5E";
                                    } else if (quarterData.reader_message === "Reading needs improvement") {
                                        bgColor = "#FFCCFF";
                                    } else if (quarterData.reader_message === "Good Reader") {
                                        bgColor = "#D5EAFF";
                                    } else if (quarterData.reader_message === "Very Good Reader") {
                                        bgColor = "#FFFF99";
                                    } else if (quarterData.reader_message === "Outstanding Reader") {
                                        bgColor = "#99FF66";
                                    } else {
                                        bgColor = "#C8C8C8";
                                    }

                                    return (
                                        <tr key={`${item._id}-${qIndex}`}>
                                            {/* <td>{index+1}</td> */}
                                            <td className='text-[12px] '>{item.erpId}</td>
                                            <td className='text-[12px]'>{quarterData.session}</td>
                                            <td className='text-[15px]'>{quarterData.quarter}</td>
                                            <td className='text-[12px]'>{item.name}</td>
                                            <td className='text-[12px]'>{item.class}</td>
                                            <td className='text-[15px]'>{item.section}</td>
                                            <td className='text-[15px]'>{quarterData.lexile}</td>
                                            <td className='text-[15px]'>{quarterData.lexile_score}</td>
                                            <td className='text-[15px]' style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{quarterData.reader_message}</td>
                                            <td className='text-[12px]'>{quarterData.selected_paragraph}</td>
                                            <td className='text-[12px]'>
                                                <button onClick={() => handleEditClick(item, quarterData)}>Evaluate</button>
                                            </td>
                                            <td className='text-[12px]'>
                                                <button onClick={() => handleRemarks(item._id)}>Remarks</button>
                                            </td>
                                            {/* <td className='text-[12px]'>
                                                <button onClick={() => handleReportCard(item._id)}><GrScorecard /></button>
                                            </td> */}
                                        </tr>
                                    );
                                });
                            } else {
                                // Display row without quarter data
                                let bgColor = "";
                                if (item.reader_message === "Reading needs urgent attention") {
                                    bgColor = "#F48C5E";
                                } else if (item.reader_message === "Reading needs improvement") {
                                    bgColor = "#FFCCFF";
                                } else if (item.reader_message === "Good Reader") {
                                    bgColor = "#D5EAFF";
                                } else if (item.reader_message === "Very Good Reader") {
                                    bgColor = "#FFFF99";
                                } else if (item.reader_message === "Outstanding Reader") {
                                    bgColor = "#99FF66";
                                } else {
                                    bgColor = "#C8C8C8";
                                }

                                return (
                                    <tr key={item._id}>
                                        <td className='text-[12px]'>{item.erpId}</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td className='text-[12px]'>{item.name}</td>
                                        <td className='text-[12px]'>{item.class}</td>
                                        <td className='text-[12px]'>{item.section}</td>
                                        <td>-</td>
                                        <td className='text-[12px]'>{item.lexile_score}</td>
                                        <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{item.reader_message}</td>
                                        <td>-</td>
                                        <td>
                                            <button className='text-[12px]' onClick={() => handleEditClick(item, null)}>Evaluate</button>
                                        </td>
                                    </tr>
                                );
                            }
                        })}

                    </tbody>
                </table>
            </div>
            {/* Hidden table for export with filtered data */}
            <table className="hidden" ref={exportTableRef}>
                <thead>
                    <tr>
                        <th>Student ID</th>
                        <th>Session</th>
                        <th>Quarter</th>
                        <th>Name</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Reading rate (wpm)</th>
                        <th>Lexile Score</th>
                        <th>Reader</th>
                        <th>Paragraph Name</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {/* {filteredData.map((item, index) => { */}
                    {currentData.map((item, index) => {
                        // Check if the student has quarter data
                        if (item.quarters && item.quarters.length > 0) {
                            return item.quarters.map((quarterData, qIndex) => {
                                let bgColor = "";
                                if (quarterData.reader_message === "Reading to be Prioritized") {
                                    bgColor = "#F48C5E";
                                } else if (quarterData.reader_message === "Reading needs improvement") {
                                    bgColor = "#FFCCFF";
                                } else if (quarterData.reader_message === "Good Reader") {
                                    bgColor = "#D5EAFF";
                                } else if (quarterData.reader_message === "Very Good Reader") {
                                    bgColor = "#FFFF99";
                                } else if (quarterData.reader_message === "Outstanding Reader") {
                                    bgColor = "#99FF66";
                                } else {
                                    bgColor = "#C8C8C8";
                                }

                                return (
                                    <tr key={`${item._id}-${qIndex}`}>
                                        {/* <td>{index+1}</td> */}
                                        <td>{item.erpId}</td>
                                        <td>{quarterData.session}</td>
                                        <td>{quarterData.quarter}</td>
                                        <td>{item.name}</td>
                                        <td>{item.class}</td>
                                        <td>{item.section}</td>
                                        <td>{quarterData.lexile}</td>
                                        <td>{quarterData.lexile_score}</td>
                                        <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{quarterData.reader_message}</td>
                                        <td>{quarterData.selected_paragraph}</td>
                                        <td>{item.remarks}</td>
                                        {/* <td>
                                            <button className='' onClick={() => handleEditClick(item, quarterData)}>Evaluate</button>
                                        </td> */}
                                        {/* <td>
                                            <button >Remarks</button>
                                        </td> */}
                                    </tr>
                                );
                            });
                        } else {
                            // Display row without quarter data
                            let bgColor = "";
                            if (item.reader_message === "Reading needs urgent attention") {
                                bgColor = "#F48C5E";
                            } else if (item.reader_message === "Reading needs improvement") {
                                bgColor = "#FFCCFF";
                            } else if (item.reader_message === "Good Reader") {
                                bgColor = "#D5EAFF";
                            } else if (item.reader_message === "Very Good Reader") {
                                bgColor = "#FFFF99";
                            } else if (item.reader_message === "Outstanding Reader") {
                                bgColor = "#99FF66";
                            } else {
                                bgColor = "#C8C8C8";
                            }

                            return (
                                <tr key={item._id}>
                                    <td>{item.erpId}</td>
                                    <td>-</td>
                                    <td>-</td>
                                    <td>{item.name}</td>
                                    <td>{item.class}</td>
                                    <td>{item.section}</td>
                                    <td>-</td>
                                    <td>{item.lexile_score}</td>
                                    <td style={{ backgroundColor: bgColor, fontWeight: 700, fontSize: "12px" }}>{item.reader_message}</td>
                                    {/* <td>
                                        <button className='' onClick={() => handleEditClick(item, null)}>Evaluate</button>
                                    </td> */}
                                </tr>
                            );
                        }
                    })}
                </tbody>
            </table>

            <div className="pagination-options">
                <div className="rows-per-page">
                    Rows per page:
                    <select value={itemsPerPage} onChange={handleRowsPerPageChange}>
                        {rowsPerPageOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
                {/* <div className="pagination">
                    <button
                        onClick={() => handlePageClick(1)}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>
                    <button
                        onClick={() => handlePageClick(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => index + 1).map(
                        (page) => (
                            <button
                                key={page}
                                onClick={() => handlePageClick(page)}
                                disabled={currentPage === page}
                            >
                                {page}
                            </button>
                        )
                    )}
                    <button
                        onClick={() => handlePageClick(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                    <button
                        onClick={() => handlePageClick(totalPages)}
                        disabled={currentPage === totalPages}
                    >
                        Last
                    </button>
                </div> */}

                {/* ...other code remains the same... */}
                <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    handlePageClick={handlePageClick}
                />
                {/* ...other code remains the same... */}
            </div>
            {/* <div className=''>
                <BarChart chartData={ChartData} />
            </div> */}

            {/* <div>
                <h1>Reading Application</h1>
                <p dangerouslySetInnerHTML={{ __html: spokenWords }}></p>

                <button onClick={startListening}>Start Reading</button>
                <button onClick={stopListening}>Stop</button>
                <button onClick={resetTranscript}>Reset</button>
            </div> */}





            {showModal && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='flex justify-between items-start'>
                            <h2 className='font-bold' >Edit Lexile</h2>
                            {/* <div className='-mt-[10px]'>
                                <MdClose onClick={handleModalClose} size={30} />
                            </div> */}

                        </div>
                        <div className='flex'>

                            <div className='w-[80%]'>
                                <form>

                                    <label>ID:</label>
                                    <input className='outline-none border-[1px] border-black ' type="text" value={selectedRow?.erpId} readOnly />
                                    {/* <label>Name:</label>
                            <input
                                type="text"
                                className='outline-none border-[1px] border-black '
                                value={selectedRow?.name}
                                onChange={(e) =>
                                    setSelectedRow((prev) => ({ ...prev, name: e.target.value }))
                                }
                                readOnly
                            /> */}

                                    {/* <label>Class:</label>
                            <input
                                type="text"
                                className='outline-none border-[1px] border-black '
                                value={selectedRow?.class}
                                onChange={(e) =>
                                    setSelectedRow((prev) => ({ ...prev, class: e.target.value }))
                                }
                                readOnly
                            /> */}

                                    {/* <label>Section:</label>
                            <input
                                type="text"
                                className='outline-none border-[1px] border-black '
                                value={selectedRow?.section}
                                onChange={(e) =>
                                    setSelectedRow((prev) => ({
                                        ...prev, section: e.target.value
                                    }))
                                }
                                readOnly
                            /> */}

                                    <label>Select Paragraph:</label>
                                    <select value={selectedRow?.selected_paragraph} onChange={(e) => setSelectedRow((prev) => ({ ...prev, selected_paragraph: e.target.value }))}
                                        className='outline-none border-[1px] border-[#6C7AE0] '>
                                        <option value="">Select Your Paragraph</option>
                                        {
                                            paragraphName && paragraphName.map((item, index) => {
                                                return (
                                                    <option key={index} value={item.paragraph_name}>{item.paragraph_name}</option>
                                                )
                                            })

                                        }
                                    </select>



                                    <label>Reading Speed:</label>
                                    {/* ----------working earlier start --------------- */}
                                    {/* <input
                                        type="number"
                                        className='outline-none border-[1px] border-[#6C7AE0] '
                                        value={selectedRow?.lexile}
                                        onChange={(e) =>
                                            setSelectedRow((prev) => ({ ...prev, lexile: e.target.value }))
                                        }
                                    /> */}
                                    {/*------------- working earlier end -------------- */}
                                    <input
                                        type="number"
                                        className='outline-none border-[1px] border-[#6C7AE0]'
                                        // value={selectedRow?.lexile }
                                        value={spokenWords.length > 1 ? spokenWords.length : selectedRow?.lexile}
                                        onChange={(e) => {
                                            const newValue = parseInt(e.target.value, 10);
                                            setSpokenWordsLength(newValue);
                                            setSelectedRow((prev) => ({ ...prev, lexile: newValue }));
                                        }}
                                    />

                                    <label>Session:</label>
                                    <input
                                        type="text"
                                        className='outline-none border-[1px] border-black '
                                        value={fetcheddefaultSession}
                                        // onChange={(e) => setSelectedRow((prev) => ({ ...prev, session: e.target.value }))}
                                        readOnly
                                    />
                                    {/* <select className='outline-none border-[1px] border-[#6C7AE0] p-[5px]' value={selectedRow?.session} onChange={(e) => setSelectedRow((prev) => ({ ...prev, session: e.target.value }))}>
                                <option value="">Select Session</option>
                                {
                                    allsessiondata && allsessiondata.map((item, index) => {
                                        return (
                                            <option key={index} value={item.name}>{item.name}</option>

                                        )
                                    })
                                }
                            </select> */}
                                    <label>Quarter:</label>
                                    <input
                                        type="text"
                                        className='outline-none border-[1px] border-black '
                                        value={fetcheddefaultQuarter}
                                        // onChange={(e) =>
                                        //     setSelectedRow((prev) => ({ ...prev, lexile: e.target.value }))
                                        // }
                                        // onChange={(e) => setSelectedRow((prev) => ({ ...prev, quarter: e.target.value }))}
                                        readOnly
                                    />

                                    {/* <select className='outline-none border-[1px] border-[#6C7AE0] p-[5px] ' value={selectedRow?.quarter} onChange={(e) => setSelectedRow((prev) => ({ ...prev, quarter: e.target.value }))}>
                                <option value="">Select Quarter</option>
                                {
                                    quarterData && quarterData.map((item, index) => {
                                        return (
                                            <option key={index} value={item.name}>{item.name}</option>

                                        )
                                    })
                                }
                            </select> */}


                                    <label htmlFor=""></label>
                                    <div className='flex justify-center '>

                                        <button disabled={showModalQuestions ? true : false} title={showModalQuestions ? "You can now close the Modal." : "Save"} className={`${showModalQuestions ? "cursor-not-allowed" : "cursor-pointer"} text-[12px]`} onClick={(e) => handleSave(e, selectedRow?._id)}>Save</button>
                                    </div>




                                    <label ></label>
                                    {/* <div className='flex gap-5 text-white mb-[5px]'>
                                <div className='cursor-pointer bg-[#6C7AE0] px-[8px] p-[5px] text-[12px] ' onClick={() => { setshowView(true); setshowModalQuestions(false) }}>View Paragraph</div>
                                <div className='cursor-pointer bg-[#6C7AE0] px-[8px] p-[5px] text-[12px]' onClick={() => { setshowView(false); setshowModalQuestions(true) }}>Ask Questions</div>
                            </div> */}

                                    {/* <label >Paragraph</label> */}







                                </form>
                            </div>
                            <div className='w-[20%]  flex justify-end'>
                                <div>
                                    <div className='flex justify-center'>
                                        <h1 className='font-bold text-[25px]'><span>00</span>:<span>{`${timerSec}`}</span></h1>
                                    </div>

                                    <div className='flex'>
                                        <button onClick={() => handleTimer()} style={{ backgroundColor: "green" }} data-aos="flip-right" data-aos-duration="3000">Start</button>
                                        <button onClick={() => handleResetTimer()} style={{ backgroundColor: "red" }}>Reset</button>
                                    </div>
                                    {
                                        timerMessage && (
                                            <div className='text-center mt-[20px] border-red-600 border-[1px] p-[2px]' data-aos="flip-right">
                                                <h1 className='text-[22px] text-red-700 font-bold'>Countdown</h1>
                                                <h1 className='text-[18px] text-red-700 font-bold'>Completed</h1>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        </div>
                        <div className='flex gap-5 text-white mb-[5px]'>
                            <div className='cursor-pointer bg-[#6C7AE0] px-[8px] p-[5px] text-[12px] ' onClick={() => { setshowView(true); setshowModalQuestions(false) }}>View Paragraph</div>
                            <div className='cursor-pointer bg-[#6C7AE0] px-[8px] p-[5px] text-[12px]' onClick={() => { setshowView(false); setshowModalQuestions(true) }}>Ask Questions</div>
                        </div>

                        <div className='  md:h-[200px] overflow-hidden overflow-y-scroll  w-full border'>

                            {
                                showView && (
                                    paragraphName &&
                                    //  paragraphName.filter((item) =>
                                    //      {
                                    //     if (selectedRow.selected_paragraph === "") {
                                    //         return
                                    //     } else {
                                    //         return item.paragraph_name === selectedRow.selected_paragraph
                                    //     }
                                    // }
                                    // )
                                    selectedRow && // Check if selectedRow is not null or undefined
                                    paragraphName
                                        .filter((item) => item.paragraph_name === selectedRow.selected_paragraph)
                                        .map((item, index) => {

                                            return (

                                                <div key={index} className='border-[1px] border-black border-collapse my-[5px] w-full '>
                                                    <div className=' w-[100%]  mt-[10px] '>
                                                        <div className='flex justify-between'>
                                                            <div>
                                                                <h1 className='text-[16px] font-bold'>{item.paragraph_name}</h1>
                                                            </div>
                                                            <div className='flex items-center gap-3'>
                                                                <div className='flex gap-2'>

                                                                    <select value={evaluateView} onChange={(e) => setevaluateView(e.target.value)}>
                                                                        <option value="">--Select View--</option>
                                                                        <option value="Basic View">Basic View</option>
                                                                        <option value="Table View">Table View</option>
                                                                    </select>
                                                                </div>
                                                                <div onClick={() => setenlargeTable(true)} className='mr-4 border border-black p-1'>
                                                                    <ImEnlarge2 size={20} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='flex gap-10'>
                                                            <div>
                                                                <h2 className='font-bold text-[14px]'>Students Age:- <span className='font-thin'>{item.student_age.join(", ")}</span></h2>
                                                            </div>
                                                            <div>
                                                                <h2 className='font-bold text-[14px]'>Grade Level:- <span className='font-thin'>{item.student_grade.join(", ")}</span></h2>
                                                            </div>
                                                        </div>
                                                        <div className='flex gap-10'>
                                                            <div>
                                                                <h2 className='font-bold text-[14px]'>Lexile Score:- <span className='font-thin'>{item.lexile_score}</span></h2>
                                                            </div>
                                                            <div>
                                                                <h2 className='font-bold text-[14px]' >Approx Word:- <span className='font-thin'>{item.approx_word_count}</span></h2>
                                                                {/* <h2 className='font-bold text-[14px] ' >Paragraph content:- <span className='font-thin'>{item.paragraph_details}</span></h2> */}

                                                            </div>
                                                        </div>

                                                        <div className={`w-[100%] border-[1px] p-[10px] ${enlargeTable ? "fixed inset-0 w-[100vw] h-[100vh] bg-white  p-[20px]" : ""}`} >
                                                            {/* {item.paragraph_details} */}
                                                            {
                                                                enlargeTable ? (
                                                                    <div className='flex justify-end mr-[20px]'>
                                                                        <FiMinimize2 className='p-[2px] border border-black' onClick={() => setenlargeTable(false)} size={30} />
                                                                    </div>
                                                                ) : null
                                                            }
                                                            <div className={`${enlargeTable ? "flex justify-center mt-[30px]" : ""}`}>


                                                                <table className='table-auto w-full'>
                                                                    <thead>
                                                                        <tr className="bg-gray-100">
                                                                            <th className={`border px-4 py-2 text-[12px] ${evaluateView === "Basic View" ? "hidden" : "Block"} `}>Serial No.</th>
                                                                            <th className="border px-4 py-2 text-[12px]">Paragraph Content</th>
                                                                            <th className={`border px-4 py-2 text-[12px] ${evaluateView === "Basic View" ? "hidden" : "Block"} `}>Word Count</th>
                                                                            <th className={`border px-4 py-2 text-[12px] ${evaluateView === "Basic View" ? "hidden" : "Block"} `}>Cumulative Word Count</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody >
                                                                        {/* for spokenwords start */}
                                                                        {/* {renderTable(item.paragraph_details, transcript.split(" "))} */}
                                                                        {/* <TableRow paragraphDetails={item.paragraph_details} spokenWords={spokenWords} /> */}
                                                                        {/* for spokenwords end */}

                                                                        {/* for transcript */}
                                                                        {/* {renderTable(paragraph, transcript)} */}
                                                                        {/* {renderTable()} */}

                                                                        {/* displaying full paragraph start  */}
                                                                        {evaluateView && evaluateView === "Basic View" ? (
                                                                            renderTableBasic(item.paragraph_details, spokenWords)
                                                                        ) : (
                                                                            renderTable(item.paragraph_details, spokenWords)
                                                                        )
                                                                        }
                                                                        {/* displaying full paragraph start  */}

                                                                        {/* Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag.start */}

                                                                        {/* Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag.end */}
                                                                    </tbody>
                                                                </table>

                                                                {
                                                                    enlargeTable ? (
                                                                        <div className='w-[20%]  flex justify-end'>
                                                                            <div>
                                                                                <div className='flex justify-center'>
                                                                                    <h1 className='font-bold text-[25px]'><span>00</span>:<span>{`${timerSec}`}</span></h1>
                                                                                </div>

                                                                                <div className='flex'>
                                                                                    <button onClick={() => handleTimer()} style={{ backgroundColor: "green" }} data-aos="flip-right" data-aos-duration="3000">Start</button>
                                                                                    <button onClick={() => handleResetTimer()} style={{ backgroundColor: "red" }}>Reset</button>
                                                                                </div>
                                                                                {
                                                                                    timerMessage && (
                                                                                        <div className='text-center mt-[20px] border-red-600 border-[1px] p-[2px]' data-aos="flip-right">
                                                                                            <h1 className='text-[22px] text-red-700 font-bold'>Countdown</h1>
                                                                                            <h1 className='text-[18px] text-red-700 font-bold'>Completed</h1>
                                                                                        </div>
                                                                                    )
                                                                                }

                                                                            </div>
                                                                        </div>

                                                                    ) : null
                                                                }

                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>

                                            )
                                        })
                                )

                            }





                            {
                                showModalQuestions && (
                                    <div className=' h-[100%] overflow-hidden overflow-y-scroll py-[10px]'>

                                        <p className='bg-[#6C7AE0] px-[8px] p-[5px] text-white'>Correct Answers:{totalYesCount}</p>
                                        <table className="w-full ">
                                            <thead>
                                                <tr className="bg-gray-100">
                                                    <th className="border px-4 py-2 text-[14px]">Quetion Name</th>
                                                    <th className="border px-4 py-2 text-[14px]">Answer for Question</th>
                                                    <th className="border px-4 py-2 w-[150px] text-[14px]">Student Answer</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    get_allQuestion && get_allQuestion.filter((item) => {
                                                        // console.log('Selected Paragraph:', selectedRow.selected_paragraph);
                                                        // console.log('Paragraph in item:', item);


                                                        if (selectedRow.selected_paragraph === "") {
                                                            return false
                                                        } else {
                                                            // return item.paragraph_id.paragraph_name === `${selectedRow.selected_paragraph}`
                                                            return item.paragraph_id.paragraph_name.trim().toLowerCase() === selectedRow.selected_paragraph.trim().toLowerCase();
                                                        }
                                                    }).map((item, index) => {
                                                        return (
                                                            <tr key={index} >
                                                                <td className="border px-2 py-2">
                                                                    <input
                                                                        type="text"
                                                                        className="w-full border rounded px-1 py-1 outline-none text-[12px]"
                                                                        readOnly
                                                                        value={item.question_name}
                                                                    />
                                                                </td>
                                                                <td className="border px-2 py-2">
                                                                    <input
                                                                        type="text"
                                                                        className="w-full border rounded px-1 py-1 outline-none text-[12px]"
                                                                        readOnly
                                                                        value={item.answer_for_question}
                                                                    />
                                                                </td>
                                                                <td className="border px-4 py-2">
                                                                    <div className="flex items-center justify-center text-[12px]">
                                                                        <div
                                                                            onClick={() => handleToggle(item._id, item.student_answer[selectedRow._id], selectedRow._id, selectedRow?.quarter, selectedRow?.session)}
                                                                            className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${item.student_answer[selectedRow._id] === "Yes" ? 'bg-green-500' : 'bg-red-500'}`}
                                                                        >
                                                                            <div
                                                                                className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${item.student_answer[selectedRow._id] === "Yes" ? 'translate-x-6' : ''}`}
                                                                            />
                                                                        </div>
                                                                        {/* <div
                                                onClick={() => handleToggle(item._id, item.student_answer[selectedRow._id], selectedRow._id, selectedRow?.quarter, selectedRow?.session)}
                                                className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${item.student_answer[selectedRow._id] === "Yes" ? 'bg-green-500' : 'bg-red-500'}`}
                                            >
                                                <div
                                                    className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${item.student_answer[selectedRow._id] === "Yes" ? 'translate-x-6' : ''}`}
                                                />
                                            </div> */}

                                                                        <span className="ml-4 text-lg font-semibold">
                                                                            {item.student_answer[selectedRow._id] === "Yes" ? 'Yes' : 'No'}
                                                                        </span>
                                                                    </div>
                                                                </td>

                                                            </tr>
                                                        )
                                                    })
                                                }



                                            </tbody>
                                        </table>

                                    </div>
                                )
                            }
                        </div>
                        <div className='flex justify-end'>
                            <button className='bg-[#6c7ae0] text-white border-none px-[12px] py-[6px] cursor-pointer  mt-[10px]' onClick={handleModalClose}>Close</button>
                        </div>

                    </div>
                </div>
            )}

            {
                remarksModal && (
                    <div className='modal'>
                        <div className='modal-content'>
                            <div className='flex justify-between items-start'>
                                <h2 className='font-bold ' >Add Remarks</h2>
                                <div className='-mt-[10px]'>
                                    <MdClose onClick={handleModalRemarksClose} size={30} />
                                </div>
                            </div>
                            <form>
                                <label>Remarks:</label>
                                <div>
                                    <p className='text-red-600 text-[12px]'>Maximum 150 characters allowed </p>
                                    <input
                                        type="text"
                                        className='outline-none border-[1px] border-[#6C7AE0] '
                                        value={getRemarks}
                                        onChange={(e) => setgetRemarks(e.target.value)}
                                    />
                                </div>
                            </form>
                            <div className='flex justify-center mt-[30px]'>
                                <button className='text-[12px]' onClick={() => updateRemarks(remarksID)}>Save</button>
                            </div>
                        </div>

                    </div>
                )
            }

            {/* previous report card working start  */}
            {/* {
                showReportCard && (
                    <div >
                        <div id={`printable`} className='inset-0 fixed flex justify-center items-center z-10 bg-black/40 w-full h-full'>
                            <div ref={printRef} className='w-[60%] h-[70vh] bg-white '>

                                <div className='REPORTCARD'>
                                    <div className='flex justify-between  py-[5px]  '>

                                        <div>
                                        </div>

                                        <div>
                                            <img src={logo} alt="report card logo" />
                                        </div>

                                        <div id={`button`} className='pr-[5px]'>
                                            <IoMdCloseCircle id={`button`} className='cursor-pointer' color='#374CC3' onClick={() => setshowReportCard(false)} size={40} />
                                        </div>
                                    </div>
                                    <div className=''>
                                        <div className='py-[10px] flex justify-center items-center text-[#374CC3] bg-white/30'>
                                            <h1 className='text-[25px] font-semibold'>Lexile Report Card</h1>
                                        </div>
                                    </div>


                                </div>

                                <div className='p-[20px] overflow-hidden overflow-y-scroll h-[45vh]'>
                                    <div className='mb-[10px] flex justify-end'>
                                        <button onClick={handlePrint} className='px-[26px] py-[8px] bg-black text-white rounded-md'>Print</button>
                                    </div>
                                    <p ><strong>{reportName}</strong> achieved a
                                        <strong>  Reading speed of </strong>
                                        {reportData && reportData.map((item, index) => {
                                            const isLastItem = index === reportData.length - 1;
                                            return (
                                                <>
                                                    <strong key={index}>  {item.reading} words  per minute in quarter {item.quarter}{isLastItem ? ' ' : ','} </strong>
                                                   
                                                </>
                                            )
                                        })}

                                        <strong> with </strong>
                                        <strong>  Lexile score of </strong>
                                        {reportData && reportData.map((item, index) => {
                                            const isLastItem = index === reportData.length - 1;
                                            return (
                                                < >
                                                    <strong key={index}>
                                                        '{item.lexile}' in quarter {item.quarter}{isLastItem ? '. ' : ' & '}
                                                    </strong>
                                                </>
                                            )
                                        })}
                                        For<strong> {reportName}</strong> regular reading is recommended to further strengthen her skills.</p>
                                    <br id={`button`} />
                                    <p><strong>At The Jaipuria School,</strong> we strongly believe that every child has the potential to be a great learner, and the key to this is strong reading skills. Language shapes us as social beings, and a child with a good command of language interacts confidently learns effectively, and grows both academically and personally.</p>
                                    <br id={`button`} />
                                    <p>Fluent speaking starts with good reading, which enhances cognitive development and linguistic skills. We assess reading speed with age-appropriate texts and measure comprehension using internationally standardized Lexile Scores. While every child learns to read, true learning begins when they read to understand.</p>
                                    <br id={`button`} />
                                    <p>As adults, we must work together as parents and teachers to support children in improving their Lexile scores, helping them develop reading comprehension as a natural skill.</p>
                                    <br id={`button`} />
                                    <p>To take the next steps in your ward’s reading journey, please connect with their English teacher—your involvement can make a meaningful difference in their growth and success.</p>
                                    <br id={`button`} />
                                    <p>Always Committed to Empowering Your Child!</p>
                                    <div>
                                        <BarChart ref={chartRef} reportData={reportData} averageLexile={reportaverageLexile} />
                                    </div>
                                </div>

                                <div>

                                </div>




                            </div>

                        </div>

                    </div>
                )
            } */}
            {/* previous report card working end  */}


            {/* naresh sir report card start  */}
            {
                showReportCard && (
                    <div >
                        <div id={`printable`} className='inset-0 fixed flex justify-center items-center z-10 bg-black/40 w-full h-full'>
                            <div ref={printRef} className='w-[60%] h-[70vh] bg-white '>

                                <div className=''>
                                    <div className='flex justify-between  py-[5px]  '>

                                        <div>
                                        </div>

                                        <div className='logo h-[100px]'>
                                            <img className='h-[120px]'
                                                src={
                                                    loggedinLocation === "Ghaziabad" || loggedinLocation === "GHAZIABAD"
                                                        ? gzp_logo
                                                        : loggedinLocation === "Kanpur" || loggedinLocation === "KANPUR"
                                                            ? knpr_logo
                                                            : loggedinLocation === "Lucknow" || loggedinLocation === "LUCKNOW"
                                                                ? lko_logo
                                                                : null // Default case if none match
                                                }
                                                // src={srjlogo}
                                                alt="report card logo"
                                            />
                                        </div>

                                        <div id={`button`} className='pr-[5px]'>
                                            <IoMdCloseCircle id={`button`} className='cursor-pointer' color='#374CC3' onClick={() => setshowReportCard(false)} size={40} />
                                        </div>
                                    </div>
                                    <div className=''>
                                        <div className='py-[10px] flex justify-center items-center text-[#374CC3] bg-white/30'>
                                            {/* <h1 className='text-[25px] font-semibold'>SETH ANANDRAM JAIPURIA SCHOOL</h1> */}
                                        </div>
                                        <div className='py-[10px] flex justify-center items-center text-[#374CC3] bg-yellow-300'>
                                            <h2 className='text-[22px] font-semibold '>STUDENT LITERACY GROWTH TRACKER</h2>
                                        </div>
                                    </div>


                                </div>

                                <div className='p-[20px] overflow-hidden overflow-y-scroll h-[45vh]'>
                                    <div className='mb-[10px] flex justify-end'>
                                        <button onClick={handlePrint} className='px-[26px] py-[8px] bg-black text-white rounded-md'>Print</button>
                                    </div>
                                    <p><strong>Student Name : </strong>{reportName}</p>
                                    <p><strong>Grade : </strong>{reportClass}</p>
                                    <br />
                                    <p>
                                        The Jaipuria Student Literacy Growth Tracker maps the development of reading
                                        and comprehension abilities in students. It is an assessment of the trademark
                                        Jaipuria Lexile Programme aimed at developing reading and comprehension skills
                                        in students to make language a means of confident expression and lifelong
                                        learning.
                                    </p>

                                    {/* {
    console.log(reportData)
} */}

                                    {reportData && reportData.map((item, index) => {
                                        const isLastItem = index === reportData.length - 1;
                                        return (
                                            <div>
                                                {isLastItem ? (
                                                    <>
                                                        <div className='py-[10px] flex justify-center items-center'>
                                                            <h2 className='text-[22px] font-semibold'>In Quarter {isLastItem ? item.quarter : ""}</h2>
                                                        </div>
                                                        <div className='flex justify-center w-full gap-[150px] gappppp'>
                                                            {/* Container for Reading Speed */}
                                                            <div className='flex flex-col items-center'>
                                                                <div className='w-[80%] h-[120px] flex justify-center'>
                                                                    <img
                                                                        className='max-w-full max-h-full object-contain'
                                                                        src={reading_speed}
                                                                        alt="reading speed"
                                                                    />
                                                                </div>
                                                                <div className='text-center border-2 border-black p-[5px] mt-2 w-[200px] xl:w-[300px]'>
                                                                    <p >{reportName} exhibited reading speed of</p>
                                                                    {isLastItem ? (
                                                                        <p key={index}>{item.reading} words per minute</p>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                            {/* Container for Lexile Score */}
                                                            <div className='flex flex-col items-center'>
                                                                <div className='w-[80%] h-[120px] flex justify-center'>
                                                                    <img
                                                                        className='max-w-full max-h-full object-contain'
                                                                        src={Lexile_child_reading}
                                                                        alt="lexile child reading"
                                                                    />
                                                                </div>
                                                                <div className='text-center border-2 border-black p-[5px] mt-2 w-[200px] xl:w-[300px]'>
                                                                    <p>{reportName} is at Lexile Score of</p>
                                                                    {isLastItem ? (
                                                                        <p key={index}>{item.lexile}</p>
                                                                    ) : ""}
                                                                </div>
                                                                <p className='mt-[5px] note text-center'>Note: Lexile Score measures comprehension</p>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : null}
                                            </div>
                                        );
                                    })}

                                    <br />


                                    <div>
                                        <p>
                                            Remarks and Observations:
                                        </p>
                                        <br />
                                        <hr className='border-black border-dotted' />
                                        <br />
                                        <hr className='border-black  border-dotted' />
                                    </div>

                                    <br />

                                    <div>
                                        <div className='py-[10px] flex justify-center items-center '>
                                            <h2 className='text-[22px] font-semibold '>Quarterly Comparative Analysis</h2>
                                        </div>

                                        <div className="report-table">
                                            <table className="w-full border-collapse border-2 border-black">
                                                <thead>
                                                    <tr className="bg-gray-200">
                                                        <th className="border-2 border-black p-2" colSpan={2}>Reading Speed</th>
                                                        <th className="border-2 border-black p-2" colSpan={2}>Evaluated on Content with Lexile Level</th>
                                                        <th className="border-2 border-black p-2" colSpan={2}>Lexile Score Achieved (Comprehension)</th>
                                                        {/* <th className="border-2 border-black p-2" colSpan={2}>Teacher Name (Signatures)</th> */}
                                                    </tr>
                                                    <tr className="bg-gray-100">
                                                        <th className="border-2 border-black p-2">Qtr 1</th>
                                                        <th className="border-2 border-black p-2">Qtr 2</th>
                                                        <th className="border-2 border-black p-2">Qtr 1</th>
                                                        <th className="border-2 border-black p-2">Qtr 2</th>
                                                        <th className="border-2 border-black p-2">Qtr 1</th>
                                                        <th className="border-2 border-black p-2">Qtr 2</th>
                                                        {/* <th className="border-2 border-black p-2">Qtr 1</th> */}
                                                        {/* <th className="border-2 border-black p-2">Qtr 2</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr className="text-center">
                                                        {/* Reading Speed for Qtr 1 and Qtr 2 */}
                                                        {/* <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === "1")?.reading || "N/A"} words per minute 
                                                        </td> */}
                                                        <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === "1")?.reading
                                                                ? `${reportData.find(item => item.quarter === "1").reading} words per minute`
                                                                : "N/A"}
                                                        </td>
                                                        <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === "2")?.reading
                                                                ? `${reportData.find(item => item.quarter === "2").reading} words per minute`
                                                                : "N/A"}
                                                        </td>

                                                        {/* Evaluated on Content with Lexile Level for Qtr 1 and Qtr 2 */}
                                                        <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === "1")
                                                                ? `${reportData.find(item => item.quarter === "1").paragraph_lexile || "N/A"}L (${reportData.find(item => item.quarter === "1").paragraphType || "N/A"})`
                                                                : "N/A"}
                                                        </td>
                                                        <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === "2")
                                                                ? `${reportData.find(item => item.quarter === "2").paragraph_lexile || "N/A"}L (${reportData.find(item => item.quarter === "2").paragraphType || "N/A"})`
                                                                : "N/A"}
                                                        </td>
                                                        <td className="border-2 border-black p-2">
                                                            {/* {reportData && reportData.find(item => item.quarter === "1")?.lexile || "N/A"} */}
                                                            {(() => {
                                                                const lexileItem = reportData && reportData.find(item => item.quarter === "1");
                                                                return lexileItem && typeof lexileItem.lexile !== "undefined" ? lexileItem.lexile : "N/A";
                                                            })()}
                                                        </td>
                                                        <td className="border-2 border-black p-2">
                                                            {/* {reportData && reportData.find(item => item.quarter === "2")?.lexile || "N/A"} */}
                                                            {(() => {
                                                                const lexileItem = reportData && reportData.find(item => item.quarter === "2");
                                                                return lexileItem && typeof lexileItem.lexile !== "undefined" ? lexileItem.lexile : "N/A";
                                                            })()}
                                                        </td>

                                                        {/* Teacher Name for Qtr 1 and Qtr 2 */}
                                                        {/* <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === 1)?.teacherName || ""}
                                                        </td> */}
                                                        {/* <td className="border-2 border-black p-2">
                                                            {reportData && reportData.find(item => item.quarter === 2)?.teacherName || ""}
                                                        </td> */}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className='mt-[80px] margin_top'>
                                        <p>Signature of teacher Term 1:</p>
                                        <br />
                                        <p>Signature of teacher Term 2:</p>
                                    </div>

                                    {/* <p ><strong>{reportName}</strong> achieved a
                                        <strong>  Reading speed of </strong>
                                        {reportData && reportData.map((item, index) => {
                                            const isLastItem = index === reportData.length - 1;
                                            return (
                                                <>
                                                    <strong key={index}>  {item.reading} words  per minute in quarter {item.quarter}{isLastItem ? ' ' : ','} </strong>

                                                </>
                                            )
                                        })}

                                        <strong> with </strong>
                                        <strong>  Lexile score of </strong>
                                        {reportData && reportData.map((item, index) => {
                                            const isLastItem = index === reportData.length - 1;
                                            return (
                                                < >
                                                    <strong key={index}>
                                                        '{item.lexile}' in quarter {item.quarter}{isLastItem ? '. ' : ' & '}
                                                    </strong>
                                                </>
                                            )
                                        })}
                                        For<strong> {reportName}</strong> regular reading is recommended to further strengthen her skills.</p>
                                    <br id={`button`} />
                                    <p><strong>At The Jaipuria School,</strong> we strongly believe that every child has the potential to be a great learner, and the key to this is strong reading skills. Language shapes us as social beings, and a child with a good command of language interacts confidently learns effectively, and grows both academically and personally.</p>
                                    <br id={`button`} />
                                    <p>Fluent speaking starts with good reading, which enhances cognitive development and linguistic skills. We assess reading speed with age-appropriate texts and measure comprehension using internationally standardized Lexile Scores. While every child learns to read, true learning begins when they read to understand.</p>
                                    <br id={`button`} />
                                    <p>As adults, we must work together as parents and teachers to support children in improving their Lexile scores, helping them develop reading comprehension as a natural skill.</p>
                                    <br id={`button`} />
                                    <p>To take the next steps in your ward’s reading journey, please connect with their English teacher—your involvement can make a meaningful difference in their growth and success.</p>
                                    <br id={`button`} />
                                    <p>Always Committed to Empowering Your Child!</p>
                                    <div>
                                        <BarChart ref={chartRef} reportData={reportData} averageLexile={reportaverageLexile} />
                                    </div> */}
                                </div>


                                <div>

                                </div>




                            </div>

                        </div>

                    </div>
                )
            }
            {/* naresh sir report card end */}


            {/* ===================rubric image start============================  */}
            {
                showRubric && showRubric ? (
                    <div>
                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                            <div className=' w-[70%] bg-white'>
                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                    <div> <h1 className='text-[30px] '>Rubric </h1></div>
                                    <div ><MdClose onClick={() => setShowRubric(false)} size={35} /></div>
                                </div>
                                <div>
                                    <div className='flex justify-center items-center'>
                                        <img src={Lexile_rubric} alt="Lexile rubric image" />

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                ) : null
            }

            {/* ===================rubric image end============================  */}



            {/* {
                showModalQuestions && (

                    <div className="modal">
                        <div className='w-[800px]'>
                            <div className=" bg-white p-[20px] rounded-md max-w-[900px] w-[800px]">
                                <h2 className='font-bold'>Update Questions</h2>

                                <div className='w-full my-[20px]'>
                                    <select value={selectedParagraph} onChange={(e) => setselectedParagraph(e.target.value)} className='outline-none border-[1px] border-black w-full py-[3px]'>
                                        <option value="">Select Your Paragraph</option>
                                        {
                                            paragraphName && paragraphName.map((item, index) => {
                                                return (
                                                    <option key={index} value={item._id}>{item.paragraph_name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </div>

                                <div className=' h-[400px] overflow-hidden overflow-y-scroll py-[10px]'>
                                    <table className="w-full ">
                                        <thead>
                                            <tr className="bg-gray-100">
                                                <th className="border px-4 py-2">Quetion Name</th>
                                                <th className="border px-4 py-2">Answer for Question</th>
                                                <th className="border px-4 py-2 w-[150px]">Student Answer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                get_allQuestion && get_allQuestion.filter((item) => {
                                                    if (selectedParagraph === "") {
                                                        return item
                                                    } else {
                                                        return item.paragraph_id._id === `${selectedParagraph}`
                                                    }
                                                }).map((item, index) => {
                                                    return (
                                                        <tr key={index} >
                                                            <td className="border px-4 py-2">
                                                                <input
                                                                    type="text"
                                                                    className="w-full border rounded px-2 py-1 outline-none"
                                                                    readOnly
                                                                    value={item.question_name}
                                                                />
                                                            </td>
                                                            <td className="border px-4 py-2">
                                                                <input
                                                                    type="text"
                                                                    className="w-full border rounded px-2 py-1 outline-none"
                                                                    readOnly
                                                                    value={item.answer_for_question}
                                                                />
                                                            </td>
                                                            <td className="border px-4 py-2">
                                                                <div className="flex items-center justify-center">
                                                                    <div
                                                                        onClick={() => handleToggle(item._id, item.student_answer[selectedRow._id], selectedRow._id)}
                                                                        className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${item.student_answer[selectedRow._id] === "Yes" ? 'bg-green-500' : 'bg-red-500'}`}
                                                                    >
                                                                        <div
                                                                            className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${item.student_answer[selectedRow._id] === "Yes" ? 'translate-x-6' : ''}`}
                                                                        />
                                                                    </div>
                                                                    <span className="ml-4 text-lg font-semibold">
                                                                        {item.student_answer[selectedRow._id] === "Yes" ? 'Yes' : 'No'}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    )
                                                })
                                            }



                                        </tbody>
                                    </table>

                                </div>
                                <button className='bg-[#6c7ae0] text-white border-none px-[12px] py-[6px] cursor-pointer  mt-[10px]' onClick={() => setshowModalQuestions(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                )
            } */}
        </div>
    );
}

// ================using this for speech recognition start ==================

// ----for spoken words start -----
// const renderTable = (paragraphDetails, spokenWords) => {
//     // console.log(spokenWords)
//     const lines = paragraphDetails.split('*').filter(line => line.trim() !== "");
//     // const spoken = spokenWords.trim().split(" "); // Split the spoken words by spaces
//     let cumulativeWordCount = -1;

//     return lines.map((line, index) => {
//         // console.log("we are here")
//         const words = line.trim().split(' ');
//         const wordCount = words.length;
//         cumulativeWordCount += wordCount;

//         // Highlighting logic for the spoken words against the current line
//         const highlightedLine = words.map((word, i) => {
//             if (i < spokenWords.length) { // Check if there's a corresponding spoken word
//                 if (word.toLowerCase() === spokenWords[i].toLowerCase()) {
//                     return `<span style="color: green; font-weight: 700">${word}</span>`; // Correct word
//                 } else {
//                     return `<span style="color: red; font-weight: 700">${word}</span>`; // Mispronounced word
//                 }
//             }
//             return word; // Default for unspoken words
//         }).join(" "); // Rejoin the words into a line

//         // const spokenWords = transcript.trim().split(" "); // Split transcript by spaces
//         // const highlightedLine = words.map((word, i) => {
//         //     if (spokenWords[i] && spokenWords[i].toLowerCase() === word.toLowerCase()) {
//         //         return `<span style="color: green; font-weight: 700">${word}</span>`;
//         //     }
//         //     if (spokenWords[i]) {
//         //         return `<span style="color: red; font-weight: 700">${word}</span>`;
//         //     }
//         //     return word; // Default unspoken words
//         // }).join(" ");

//         return (
//             <tr key={index} className='hover:bg-[#6c7ae0]/40'>
//                 <td className="border px-4 py-2 text-[12px]">{index + 1}</td>
//                 {/* <td className="border px-4 py-2 text-[12px]">{line}</td> */}
//                 <td
//                     className="border px-4 py-2 text-[12px]"
//                     dangerouslySetInnerHTML={{ __html: highlightedLine }} // Inject highlighted content
//                 />
//                 <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//                 <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
//             </tr>
//         );
//     });

// };
// ----for spoken words end -----

// -------for transcript start -------
// const renderTable = (paragraphDetails, transcript) => {
//     const lines = paragraphDetails.split("*").filter(line => line.trim() !== "");
//     let cumulativeWordCount = 0;

//     // Determine which line is currently being read
//     const transcriptWords = transcript.trim().split(" ");
//     let currentLineIndex = -1;

//     lines.forEach((line, index) => {
//         const words = line.trim().split(" ");
//         if (transcriptWords.every((word, i) => words[i]?.toLowerCase() === word.toLowerCase())) {
//             currentLineIndex = index; // Identify the line being read
//         }
//     });

//     return lines.map((line, index) => {
//         const words = line.trim().split(" ");
//         const wordCount = words.length;
//         cumulativeWordCount += wordCount;

//         let highlightedLine;
//         if (index === currentLineIndex) {
//             // Highlight the current line
//             highlightedLine = words.map((word, i) => {
//                 if (transcriptWords[i]?.toLowerCase() === word.toLowerCase()) {
//                     return `<span style="color: green; font-weight: 700">${word}</span>`;
//                 }
//                 return `<span style="color: red; font-weight: 700">${word}</span>`;
//             }).join(" ");
//         } else {
//             // Leave other lines unhighlighted
//             highlightedLine = words.join(" ");
//         }

//         return (
//             <tr key={index} className="hover:bg-[#6c7ae0]/40">
//                 <td className="border px-4 py-2 text-[12px]">{index + 1}</td>
//                 <td
//                     className="border px-4 py-2 text-[12px]"
//                     dangerouslySetInnerHTML={{ __html: highlightedLine }} // Inject highlighted content
//                 />
//                 <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//                 <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
//             </tr>
//         );
//     });
// };
// Render table with highlighting
// const renderTable = () => {
//     const lines = paragraph.split("*").filter(line => line.trim() !== "");
//     let cumulativeWordCount = 0;

//     return lines.map((line, index) => {
//         const words = line.trim().split(" ");
//         const wordCount = words.length;
//         cumulativeWordCount += wordCount;

//         // Highlight words in the current line
//         const highlightedLine = words.map(word => {
//             if (cumulativeSpokenWords.includes(word)) {
//                 return `<span style="color: green; font-weight: 700">${word}</span>`;
//             }
//             return `<span style="color: red; font-weight: 700">${word}</span>`;
//         }).join(" ");

//         return (
//             <tr key={index} className="hover:bg-[#6c7ae0]/40">
//                 <td className="border px-4 py-2 text-[12px]">{index + 1}</td>
//                 <td
//                     className="border px-4 py-2 text-[12px]"
//                     dangerouslySetInnerHTML={{ __html: highlightedLine }} // Inject highlighted content
//                 />
//                 <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//                 <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
//             </tr>
//         );
//     });
// };
// -------for transcript end -------

//-------------- display full paragraph start ---------------
// const renderTable = (paragraphDetails, spokenWords) => {
//     // Combine all lines into one paragraph
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" "); // Split paragraph into individual words

//     // Highlight words based on spoken words
//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length) {
//             console.log(spokenWords)
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span style={{ color: "green", fontWeight: 500 }}>{word} </span>; // Correct word
//             } else {
//                 return <span style={{ color: "red", fontWeight: 500 }}>{word} </span>; // Mispronounced word
//             }
//         }
//         return <span>{word} </span>; // Default unspoken words
//     });

//     // Calculate word count
//     const wordCount = paragraphWords.length;

//     return (
//         <tr  className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td> {/* Cumulative word count for the single paragraph */}
//         </tr>
//     );
// };

// const renderTable = (paragraphDetails, spokenWords) => {
//     const TableRow = ({ paragraphDetails, spokenWords }) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" ");

//     // Memoize highlighted paragraph to avoid unnecessary recalculations
//     const highlightedParagraph = useMemo(() => {
//         return paragraphWords.map((word, index) => {
//             if (index < spokenWords.length) {
//                 const isCorrect = word.toLowerCase() === spokenWords[index].toLowerCase();
//                 return (
//                     <span
//                         key={index}
//                         style={{
//                             color: isCorrect ? "green" : "red",
//                             fontWeight: 700,
//                         }}
//                     >
//                         {word}{" "}
//                     </span>
//                 );
//             }
//             return <span key={index}>{word} </span>;
//         });
//     }, [paragraphWords, spokenWords]);

//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };

// const computeHighlightedParagraph = (paragraphWords, spokenWords) => {
//     return paragraphWords.map((word, index) => {
//         if (index < spokenWords.length) {
//             const isCorrect = word.toLowerCase() === spokenWords[index].toLowerCase();
//             return (
//                 <span
//                     key={index}
//                     style={{
//                         color: isCorrect ? "green" : "red",
//                         fontWeight: 700,
//                     }}
//                 >
//                     {word}{" "}
//                 </span>
//             );
//         }
//         return <span key={index}>{word} </span>;
//     });
// };

// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" ");
//     const highlightedParagraph = computeHighlightedParagraph(paragraphWords, spokenWords);
//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };
// const renderTable = (paragraphDetails, spokenWords) => {
//     // Combine all lines into one paragraph
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" "); // Split paragraph into individual words

//     // Synchronize spoken words with the paragraph
//     const truncatedSpokenWords = spokenWords.slice(0, paragraphWords.length);

//     // Highlight words based on spoken words
//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < truncatedSpokenWords.length) {
//             console.log(truncatedSpokenWords)
//             if (word.toLowerCase() === truncatedSpokenWords[index].toLowerCase()) {
//                 return <span style={{ color: "green", fontWeight: 500 }}>{word} </span>; // Correct word
//             } 
//             else {
//                 return <span style={{ color: "red", fontWeight: 500 }}>{word} </span>; // Mispronounced word
//             }
//         }
//         return <span>{word} </span>; // Default unspoken words
//     });

//     // Calculate word count
//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td> {/* Cumulative word count for the single paragraph */}
//         </tr>
//     );
// };




//-------------- display full paragraph end ---------------


//--------- Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag start--------
// const renderTable = (paragraphDetails, spokenWords) => {
//     // Combine all lines into one paragraph
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" "); // Split paragraph into individual words

//     // Flag to stop highlighting after the first mismatch
//     let shouldHighlight = true;

//     // Highlight words based on spoken words
//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length && shouldHighlight) {
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span style={{ color: "green", fontWeight: 500 }}>{word} </span>; // Correct word
//             } else {
//                 shouldHighlight = false; // Stop highlighting after first mismatch
//                 return <span style={{ color: "red", fontWeight: 500 }}>{word} </span>; // Mispronounced word
//             }
//         }
//         return <span>{word} </span>; // Default unspoken words
//     });

//     // Calculate word count
//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td> {/* Cumulative word count for the single paragraph */}
//         </tr>
//     );
// };

// const renderTable = (paragraphDetails, spokenWords) => {
//     if (!paragraphDetails || !spokenWords) return null;

//     const paragraphWords = paragraphDetails.split(" ").filter(Boolean);

//     let cumulativeWordCount = 0;
//     const rows = paragraphWords.map((word, index) => {
//         cumulativeWordCount += word.length;

//         return (
//             <tr key={index} className="hover:bg-gray-200">
//                 <td className="border px-4 py-2 text-[12px]">{index + 1}</td>
//                 <td className="border px-4 py-2 text-[12px]">{word}</td>
//                 <td className="border px-4 py-2 text-[12px]">{word.length}</td>
//                 <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
//             </tr>
//         );
//     });

//     return rows;
// };

// -----working one start------
// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" "); // Split paragraph into individual words

//     let mispronouncedIndex = -1; // Index where mispronunciation happened
//     let shouldHighlight = true; // Flag to stop highlighting after the first error

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         // Check if spoken words exist and comparison hasn't stopped
//         if (index < spokenWords.length) {
//             console.log(spokenWords)
//             if (shouldHighlight) {
//                 // Correctly pronounced word
//                 if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                     return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//                 } else {
//                     // Mispronounced word
//                     shouldHighlight = false;
//                     mispronouncedIndex = index; // Store the mispronounced index
//                     return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//                 }
//             } else {
//                 // Resume highlighting if the user pronounces correctly after an error
//                 if (mispronouncedIndex >= 0 && word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                     shouldHighlight = true; // Resume highlighting
//                     return <span style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//                 }
//                 // Default rendering while waiting for correct pronunciation
//                 return <span key={index}>{word} </span>;
//             }
//         }
//         // Render words that haven't been spoken yet
//         return <span>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr key={wordCount} className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td> {/* Cumulative word count */}
//         </tr>
//     );
// };
// -----working one end------

// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" "); // Split paragraph into individual words

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         // Highlight only the words that match the spokenWords array
//         if (index < spokenWords.length) {
//             console.log(spokenWords)
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }
//         // Render words not yet spoken
//         return <span key={index}>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr key={wordCount} className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td> {/* Cumulative word count */}
//         </tr>
//     );
// };


// const renderTable = (paragraphDetails, spokenWords) => {
//     // Split paragraph into an array of words
//     const paragraphWords = paragraphDetails.split(" ").map(word => word.trim());

//     let currentIndex = 0; // Index to track where the user is in the paragraph
//     let shouldCompare = true; // Flag to determine if comparison should continue

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         // Normalize paragraph word (remove punctuation)
//         const normalizedWord = word.replace(/[.,!?;:*]/g, "").toLowerCase();

//         if (shouldCompare && currentIndex < spokenWords.length) {
//             const spokenWord = spokenWords[currentIndex].toLowerCase();
//             console.log(spokenWords)
//             if (normalizedWord === spokenWord) {
//                 // Correctly pronounced word
//                 currentIndex++; // Move to the next word
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 // Mispronounced word
//                 shouldCompare = false; // Stop comparison
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }

//         // Render words after mispronunciation without highlighting
//         return <span key={index}>{word} </span>;
//     });

//     return (
//         <tr key="highlighted-row" className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td> {/* Assuming single paragraph */}
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{paragraphWords.length}</td>
//             <td className="border px-4 py-2 text-[12px]">{spokenWords.length}</td> {/* Cumulative word count */}
//         </tr>
//     );
// };



//--------------------- using copilot start -----------------------
// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" ");
//     let mispronounced = false;

//     console.log("Paragraph Words:", paragraphWords);
//     console.log("Spoken Words:", spokenWords);

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length && !mispronounced) {
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 mispronounced = true;
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }
//         return <span key={index}>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };


// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" ");
//     let mispronounced = false;

//     console.log("Paragraph Words:", paragraphWords);
//     console.log("Spoken Words:", spokenWords);

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length && !mispronounced) {
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 mispronounced = true;
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }
//         return <span key={index}>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };



// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     const paragraphWords = fullParagraph.split(" ");

//     console.log("Paragraph Words:", paragraphWords);
//     console.log("Spoken Words:", spokenWords);

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length) {
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }
//         return <span key={index}>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };

// working fine generated with copilot start 
// const renderTable = (paragraphDetails, spokenWords) => {
//     const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
//     let paragraphWords = fullParagraph.split(" ");
//     paragraphWords = paragraphWords.filter(word => word.trim() !== ""); // Filter out empty strings

//     console.log("Paragraph Words:", paragraphWords);
//     console.log("Spoken Words:", spokenWords);

//     const highlightedParagraph = paragraphWords.map((word, index) => {
//         if (index < spokenWords.length) {
//             if (word.toLowerCase() === spokenWords[index].toLowerCase()) {
//                 return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
//             } else {
//                 return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
//             }
//         }
//         return <span key={index}>{word} </span>;
//     });

//     const wordCount = paragraphWords.length;

//     return (
//         <tr className="hover:bg-[#6c7ae0]/40">
//             <td className="border px-4 py-2 text-[12px]">1</td>
//             <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//             <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//         </tr>
//     );
// };
// working fine generated with copilot end


const renderTableBasic = (paragraphDetails, spokenWords, ONENLARGE) => {
    const fullParagraph = paragraphDetails.split("*").filter(line => line.trim() !== "").join(" ");
    let paragraphWords = fullParagraph.split(" ");
    paragraphWords = paragraphWords.filter(word => word.trim() !== ""); // Filter out empty strings

    // Function to remove punctuation from a word
    const removePunctuation = (word) => {
        return word.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").toLowerCase();
    };

    console.log("Paragraph Words:", paragraphWords);
    console.log("Spoken Words:", spokenWords);

    const highlightedParagraph = paragraphWords.map((word, index) => {
        if (index < spokenWords.length) {
            if (removePunctuation(word) === removePunctuation(spokenWords[index])) {
                return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
            } else {
                return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
            }
        }
        return <span key={index}>{word} </span>;
    });

    const wordCount = paragraphWords.length;

    return (
        <tr className={`hover:bg-[#6c7ae0]/40 `}>
            {/* <td className="border px-4 py-2 text-[12px]">1</td> */}
            <td className="border px-4 py-2 text-[15px]">{highlightedParagraph}</td>
            {/* <td className="border px-4 py-2 text-[12px]">{wordCount}</td> */}
            {/* <td className="border px-4 py-2 text-[12px]">{wordCount}</td> */}
        </tr>
    );
};



//------------ seprate paragraph into lines start  ------------------
const renderTable = (paragraphDetails, spokenWords) => {
    const lines = paragraphDetails.split("*").filter(line => line.trim() !== "");
    let cumulativeWordCount = 0;

    // Function to remove punctuation from a word
    const removePunctuation = (word) => {
        return word.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").toLowerCase();
    };

    const renderLine = (line, lineIndex) => {
        const paragraphWords = line.split(" ").filter(word => word.trim() !== "");
        // console.log("Paragraph Words:", paragraphWords);
        // console.log("Spoken Words:", spokenWords);

        const highlightedParagraph = paragraphWords.map((word, index) => {
            const spokenWordIndex = cumulativeWordCount + index;
            if (spokenWordIndex < spokenWords.length) {
                if (removePunctuation(word) === removePunctuation(spokenWords[spokenWordIndex])) {
                    return <span key={index} style={{ color: "green", fontWeight: 500 }}>{word} </span>;
                } else {
                    return <span key={index} style={{ color: "red", fontWeight: 500 }}>{word} </span>;
                }
            }
            return <span key={index}>{word} </span>;
        });

        const wordCount = paragraphWords.length;
        cumulativeWordCount += wordCount;

        return (
            <tr key={lineIndex} className="hover:bg-[#6c7ae0]/40">
                <td className="border px-4 py-2 text-[12px]">{lineIndex + 1}</td>
                <td className="border px-4 py-2 text-[12px]">{highlightedParagraph}</td>
                <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
                <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
            </tr>
        );
    };

    return lines.map((line, index) => renderLine(line, index));
};
//------------ seprate paragraph into lines end  ------------------










//--------------------- using copilot end -----------------------





















// const highlightedTable = useMemo(() => renderTable(paragraph, spokenWords), [paragraph, spokenWords]);


//--------- Update the renderTable function to stop highlighting when a word is mispronounced, ensuring errors do not cascade. Track whether the comparison should continue using a flag end--------


// ============using this for speech recognition end===================

// const renderTable = (paragraphDetails) => {
//     const lines = paragraphDetails.split('*').filter(line => line.trim() !== "");
//     let cumulativeWordCount = 0;

//     return lines.map((line, index) => {
//         const words = line.trim().split(' ');
//         const wordCount = words.length;
//         cumulativeWordCount += wordCount;

//         return (
//             <tr key={index} className='hover:bg-[#6c7ae0]/40'>
//                 <td className="border px-4 py-2 text-[12px]">{index + 1}</td>
//                 <td className="border px-4 py-2 text-[12px]">{line}</td>
//                 <td className="border px-4 py-2 text-[12px]">{wordCount}</td>
//                 <td className="border px-4 py-2 text-[12px]">{cumulativeWordCount}</td>
//             </tr>
//         );
//     });

// };



export default DataTable;






